(function () {
	'use strict';

	angular
		.module('grootRpm', ['ngAnimate', 'ngSanitize', 'ngMessages',
			'ngAria', 'cgBusy', 'angularFileUpload', 'ang-drag-drop',
			'hc.marked', 'ui.router', 'ngMaterial', 'toastr', 'ngStorage',
			'grootRpm.environments', 'truncate', 'pascalprecht.translate',
			'fc.paging'
		]);
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('DeviceUpdateController', DeviceUpdateController);

    /** @ngInject */
    function DeviceUpdateController($stateParams, devicesService, toastr,
        $q, authenticationService, $state, pinsLayoutService) {
        var vm = this;
        var deviceCopy;
        vm.edit = true;
        vm.layoutLocked = true;
        vm.device = {
            keyWords: []
        };

        activate();

        function activate() {
            var devicePromise = devicesService.getDeviceByModel(
                    $stateParams.model)
                .then(function(response) {
                    vm.device = response.data;
                    checkAuthentication();

                    var uploaderDevice = angular.copy(response.data);
                    pinsLayoutService.broadcastLayout(vm,
                        uploaderDevice);

                    vm.uploaderDevice = uploaderDevice;
                    vm.device.usageLevel = vm.device.usageLevel ? vm.device
                        .usageLevel.id : null;
                    vm.device.electricitySupply = vm.device.electricitySupply ?
                        vm.device.electricitySupply.id : vm.device.electricitySupply;
                    vm.device.singleWorkingVoltage = vm.device.singleWorkingVoltage ?
                        vm.device.singleWorkingVoltage.id : vm.device.singleWorkingVoltage;
                    vm.device.dataBus = getDataBusList(vm.device.dataBus);

                    deviceCopy = angular.copy(vm.device);
                    vm.layoutLocked = false;
                }, function(error) {
                    error.pop();
                });

            var templatePromise = devicesService.getDeviceTemplate()
                .then(function(response) {
                    vm.template = response.data;
                    pinsLayoutService.broadcastTemplate(vm.template);
                }, function(error) {
                    error.pop();
                });

            vm.promise = $q.all([devicePromise, templatePromise]).then(
                function() {

                });

        }

        function getDataBusList(dataBus) {
            var dataBusIdList = [];
            if (dataBus)
                for (var i = dataBus.length - 1; i >= 0; i--) {
                    dataBusIdList.push(dataBus[i].id);
                }
            return dataBusIdList;
        }

        function checkAuthentication() {
            if (!authenticationService.isAuthenticated() ||
                authenticationService.getUser().id != vm.device.creatorId) {
                $state.go('404');
            }
        }

        vm.updateDeviceBasic = function() {
            vm.layoutLocked = true;
            if (vm.device.hasMultipleVoltage) {
                vm.device.singleWorkingVoltage = '';
            } else {
                vm.device.multipleWorkingVoltage = '';
            }

            vm.promise = devicesService.updateDevice(vm.device)
                .then(function(response) {
                    vm.uploaderDevice = angular.copy(response.data);
                    vm.layoutLocked = false;

                    toastr.success("DEVICE.UPDATE_DEVICE_SUCCESS");
                }, function(error) {
                    error.pop();
                });
        };

        vm.cancelEditBasic = function() {
            vm.device = angular.copy(deviceCopy);
        };
    }
})();
(function() {
	'use strict';
	angular.module('grootRpm').controller('PinsLayoutShowController',
		PinsLayoutShowController);

	/** @ngInject */
	function PinsLayoutShowController(devicesService,
		$scope, pinsLayoutService) {
		var vm = this, deviceModel;
		vm.generateColor = pinsLayoutService.generateColor;
		vm.inputPins;
		vm.outputPins;

		vm.layoutImageSuccess = true;

		vm.hasInputPins = function() {
			return vm.inputPins && vm.inputPins.length > 0;
		};
		vm.hasOutputPins = function() {
			return vm.outputPins && vm.outputPins.length > 0;
		};
        vm.hasPowerPins = function() {
            return vm.powerPins && vm.powerPins.length > 0;
        };
        vm.hasGroundPins = function() {
            return vm.groundPins && vm.groundPins.length > 0;
        };

		pinsLayoutService.onLayout($scope, function(event, data) {
			var device = data.deviceController.device;
			deviceModel = device.model;
			vm.imageSrc = pinsLayoutService.urlOfLayoutImage(deviceModel);
		});

		$scope.$on('layoutImageLoadError', function(){
			vm.layoutImageSuccess = false;
		});

		$scope.$on('boardDrawed', function(event, args) {
			vm.image = args;
			var ratio = vm.image.ratio;
			vm.layoutImageSuccess = true;

			vm.promise = devicesService.getLayoutByModel(deviceModel).then(function(response) {
                var device = response.data, pins = device.devicePins;
                var dbRatio = vm.image.realWidth/ device.deviceImageWidth;
                var groupPins = [], viewPins = [],
                    inputPins = [], outputPins = [];
                pins.forEach(function(pin) {
                    var gPin = pinsLayoutService.pinFromServer(pin);
                    groupPins.push(gPin);
                });
                groupPins.forEach(function(gPin) {
                    if (!gPin.pins) {
                        viewPins.push(gPin);
                    } else {
                        Array.prototype.push.apply(viewPins, gPin.pins);
                    }
                });

                viewPins.forEach(function(pin) {
                    pin.x = pin.xPosition * dbRatio / ratio;
                    pin.y = pin.yPosition * dbRatio / ratio;
                });

                viewPins.forEach(function(pin) {
                    if (pin.io === "IN") {
                        inputPins.push(pin);
                    } else if (pin.io === "OUT") {
                        outputPins.push(pin);
                    }
                });

                vm.pins = viewPins;
                vm.inputPins = inputPins;
                vm.outputPins = outputPins;
            }, function(error) {
                error.pop();
            });
		});

		vm.striking = pinsLayoutService.striking;

	}
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('DeviceShowController', DeviceShowController);

    /** @ngInject */
    function DeviceShowController($stateParams, devicesService, $q,
        ImageBaseUrl, authenticationService, $state, pinsLayoutService) {
        var vm = this;
        vm.showEditButton = false;

        activate();

        function activate() {
            vm.promise = devicesService.getDeviceByModel($stateParams.model)
                .then(function(response) {
                    vm.device = response.data;
                    pinsLayoutService.broadcastLayout(vm);
                    vm.drivers = vm.device.drivers;
                    mergeDrivers();
                    showEditButtonIfOwned();
                    getUploaded();
                }, function(error) {
                    if (error.isNotFound()) {
                        $state.go('404');
                    }
                    error.pop();
                });
        }
        vm.isFileExist = function(key) {
            return vm.uploaded.indexOf(key) != -1 || false;
        }
        vm.downloadOtherFile = function(type) {
            var model = vm.device.model,
                url = ImageBaseUrl + "devices/" + model +
                "/doc/download/" + type.toLowerCase();
            window.open(url, "_blank");
        }

        function getUploaded() {
            devicesService.getDeviceUploadedByModel(vm.device.model)
                .then(function(response) {
                    vm.uploaded = response.data;
                });
        }

        function showEditButtonIfOwned() {
            if (authenticationService.isAuthenticated() &&
                authenticationService.getUser().id == vm.device.creatorId) {
                vm.showEditButton = true;
            }
        }

        function mergeDrivers() {
            var latestDriverMap = {};
            vm.drivers.forEach(function(driver) {
                var name = driver.name;
                if (latestDriverMap.hasOwnProperty(name)) {
                    if (driver.id > latestDriverMap[name].id) {
                        latestDriverMap[name] = driver;
                    }
                } else {
                    latestDriverMap[name] = driver;
                }
            });

            vm.drivers = Object
                .keys(latestDriverMap)
                .map(function(name) {
                    return latestDriverMap[name];
                });
        }
    }
})();
(function() {
	'use strict';
	angular
		.module('grootRpm')
		.controller('OtherFileUploadController', OtherFileUploadController);

	// 枚举：上传文件的状态
	var UPLOAD_NONE = "NONE",
		UPLOAD_ING = "ING",
		UPLOAD_DONE = "DONE";

	var GLOBLE_fileUploaderFactory, GLOBLE_toastr, GLOBLE_ApiBaseUrl, GLOBLE_http,
		GLOBLE_$translate;

	/** @ngInject */
	function OtherFileUploadController(fileUploaderFactory, toastr, ApiBaseUrl,
		$http, $translate,
		$scope, pinsLayoutService, devicesService) {
		GLOBLE_fileUploaderFactory = fileUploaderFactory;
		GLOBLE_toastr = toastr;
		GLOBLE_ApiBaseUrl = ApiBaseUrl;
		GLOBLE_http = $http;
		GLOBLE_$translate = $translate;

		var vm = this,
			materials = [],
			imageTypes = ["jpg", "png", "jpeg", "bmp", "gif"];
		var TYPE_CERT = "CERT" /*证书*/ ,
			TYPE_MANU = "MANU" /*手册*/ ,
			TYPE_BAGP = "BAGP" /*原理图*/ ,
			TYPE_PCBP = "PCBP" /*PCB图*/ ,
			TYPE_CAPI = "CAPI" /*封装信息*/ ,
			TYPE_SDKP = "SDKP" /*SDK*/ ;

		pinsLayoutService.onLayout($scope, function(event, data) {
			var deviceController = data.deviceController,
				realDevice = data.realDevice;
			var model = vm.model = realDevice.model;
			vm.deviceController = deviceController;
			materials.length = 0;
			materials.push(new Material(model, TYPE_CERT,
				"CERTIFICATE", imageTypes, true, 'fa-certificate'));
			materials.push(new Material(model, TYPE_MANU,
				"MANUAL", ["pdf"], true, 'fa-book'));
			materials.push(new Material(model, TYPE_BAGP,
				"SCHEMATIC_DIAGRAM", imageTypes, false, 'map'));
			materials.push(new Material(model, TYPE_PCBP,
				"PCB", imageTypes, false, 'developer_board'));
			materials.push(new Material(model, TYPE_CAPI,
				"PACKAGING_INFO", ["pdf"], false, 'memory'));
			materials.push(new Material(model, TYPE_SDKP,
				"SDK", ["pdf"], false, 'developer_mode'));

			vm.materials = materials;

			if (deviceController.edit) {
				devicesService.getDeviceUploadedByModel(vm.model)
					.then(function(response) {
						var uploaded = response.data;
						uploaded.forEach(function(u) {
							for (var i = 0; i < vm.materials.length; i++) {
								if (vm.materials[i].type === u) {
									vm.materials[i].lastState = UPLOAD_DONE;
									break;
								}
							}
						});
					});
			}
		});

		vm.skipToNext = function() {
			vm.deviceController.detailInfoLocked = false;
			vm.deviceController.selectedTab += 1;
			vm.deviceController.otherFilesLocked = true;
		};
	}

	function Material(model, type, label, fileTypes, isFontAwesomeIcon, icon) {
		this.model = model;
		this.type = type;
		this.icon = icon;
		this.isFontAwesomeIcon = isFontAwesomeIcon;
		this.label = label;
		this.fileTypes = fileTypes || [];

		this.progress = 0;
		this.state = UPLOAD_NONE; //当前上传文件的状态
		this.lastState = UPLOAD_NONE; //最后一次合法的状态
		this.initFileUploader();
	}

	(function() {

		function uploadUrl(material) {
			return GLOBLE_ApiBaseUrl + 'devices/' + material.model +
				'/doc/publish/' + material.type.toLowerCase();
		}

		// 初始化 fileUploader
		Material.prototype.initFileUploader = function() {
			var self = this;
			var uploader = GLOBLE_fileUploaderFactory.create({
				url: uploadUrl(self),
				alias: 'file',
				autoUpload: true,
				onAfterAddingFile: function(item) {
					if (item.file.size > GLOBLE_fileUploaderFactory.maxFileSize) {
						item.remove();
						GLOBLE_toastr.error("DEVICE.OUT_OF_RANGE_FILE_SIZE");
					}
				},
				onBeforeUploadItem: function(item) {
					self.progress = 0;
				},
				onSuccessItem: function(item) {
					self.state = UPLOAD_DONE;
					self.lastState = UPLOAD_DONE;
					self.progress = item.progress;

					GLOBLE_toastr.success("DEVICE.UPLOAD_FILE_SUCCESS");
				},
				onErrorItem: function() {
					self.state = UPLOAD_NONE;
					self.progress = 0;
					GLOBLE_toastr.error("DEVICE.UPLOAD_FILE_FAIL");
				},
				onProgressItem: function(item) {
					self.state = UPLOAD_ING;
					self.progress = item.progress;
				}
			});

			uploader.filters.push({
				name: 'fileName',
				fn: function(item) {
					var maxLength = GLOBLE_fileUploaderFactory.maxFileNameLength;
					if (item.name.length > maxLength) {
						GLOBLE_$translate("DEVICE.FILE_NAME_TOO_LONG",
							{ length: maxLength }).then(function success(info) {
							GLOBLE_toastr.warning(info);
						});
						return false;
					}
					return true;
				}
			});

			this.fileUploader = uploader;
		};
	})();
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('OptionalInfoController', OptionalInfoController);

    /** @ngInject */
    function OptionalInfoController(devicesService,
        pinsLayoutService, toastr, $state, $scope) {
        var vm = this;

        vm.skipToNext = function () {
            vm.deviceController.driversLocked = false;
            vm.deviceController.selectedTab += 1;
            vm.deviceController.detailInfoLocked = true;
        };

        pinsLayoutService.onLayout($scope, function(event, data) {
            vm.deviceController = data.deviceController;
            vm.device = vm.deviceController.device;
            if (!vm.device.id) {
                vm.device.id = data.realDevice.id;
            }
        });

        pinsLayoutService.onTemplate($scope, function(event, template) {
            vm.template = template;
        });

        vm.createDeviceDetail = function() {
            if (vm.device.hasMultipleVoltage) {
                vm.device.singleWorkingVoltage = '';
            } else {
                vm.device.multipleWorkingVoltage = '';
            }
            vm.promise = devicesService.createDeviceDetail(vm.device)
                .then(function() {
                    toastr.success("DEVICE.CREATE_SUCCESS");
                    vm.skipToNext();
                }, function(error) {
                    error.pop();
                });
        };

        vm.updateDeviceBasic = function () {
            vm.deviceController.updateDeviceBasic();
        };

        vm.cancelEditBasic = function () {
            vm.deviceController.cancelEditBasic();
            vm.device = vm.deviceController.device;
        };
    }
})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .controller('FileUploadController', FileUploadController);

    /** @ngInject */
    function FileUploadController(fileUploaderFactory, devicesService,
        toastr, $scope, pinsLayoutService, $translate) {

        var eventOffsetKey = "__drag-event-offset";
        var lastEventOffset;
        $scope.$on('ANGULAR_DRAG_START', function(scope, event, sendChannel, transferDataObject) {
            if (sendChannel !== 'board') return;
            var pinDom = event.currentTarget;
            lastEventOffset = {
                x: event.offsetX, y: event.offsetY
            };
        });

        var vm = this; vm.pins = [];
        // pinService
        var pinService = (function(){
            function existPin(name) {
                var pin, i, pins = vm.groupPins, size = pins.length;
                for (i = 0; i< size; i++) {
                    pin = pins[i];
                    if (pin.pin === name) return true;
                }
                return false;
            }

            function removePinPoint(pin) {
                var count = vm.pins.length, i, p, newVmPins = [];
                for (i = 0; i < count; i++) {
                    p = vm.pins[i];
                    if (p._uniqueId !== pin._uniqueId) {
                        newVmPins.push(p);
                    }
                }

                vm.pins = newVmPins;

                var newGroupPins = [];
                count = vm.groupPins.length;
                for (i = 0; i < count; i++) {
                    p = vm.groupPins[i];
                    if (p._uniqueId !== pin._uniqueId) {
                        newGroupPins.push(p);
                        if (p.pins && p.pins.length) {
                            var newPins = [];
                            p.pins.forEach(function(p){
                                if (p._uniqueId !== pin._uniqueId) {
                                    newPins.push(p);
                                }
                            });
                            p.pins = newPins;
                        }
                    } else {
                        p.pins && p.pins.forEach(function(p){
                            removePinPoint(p);
                        });
                    }
                }

                vm.groupPins = newGroupPins;
            }

            function striking(pin) {
                pinsLayoutService.striking(pin);
            }

            return {
                generateColor: pinsLayoutService.generateColor,
                existPin: existPin,
                removePinPoint: removePinPoint,
                striking: striking
            };
        })();

        vm.pinService = pinService; vm.saveLayout = saveLayout;
        vm.image = {}; vm.device = {}; vm.layoutImage = {};
        vm.onDrop = onDrop;

        vm.imageUploader = (function(vm){
            var fileUploader = fileUploaderFactory.create({
                url: '', alias: 'image', autoUpload: true,
                onAfterAddingFile: function(item) {
                    if (item.file.size > fileUploaderFactory.maxFileSize) {
                        item.remove();
                        toastr.error("DEVICE.OUT_OF_RANGE_IMAGE_SIZE");
                    } else {
                        fileUploader._showProcess = true;
                        fileUploader._lastItem = vm.layoutImage.lastItem;
                    }
                },
                onProgressItem: function (item) {
                    vm.layoutImage.lastItem = {
                        file: item._file,
                        progress: item.progress
                    };
                },
                onSuccessItem: function (item) {
                    vm.imageUploaded = true;
                    vm.layoutImage.lastItem = {
                        file: item._file,
                        progress: item.progress,
                        saved: false //是否已经保存到数据库
                    };
                    fileUploader._showProcess = false;
                },
                onErrorItem: function () {
                    fileUploader._showProcess = false;
                    vm.layoutImage.lastItem = fileUploader._lastItem;
                    toastr.error("DEVICE.UPLOAD_IMAGE_FAIL");
                }
            });

            fileUploader._showProcess = false;
            fileUploader.isCalled = function() {
                var lastItem = vm.layoutImage.lastItem;
                return !!(lastItem && lastItem.progress !== undefined);
            };

            fileUploader.isShowProcess = function() {
                return fileUploader._showProcess;
            },
            fileUploader.getProcess = function() {
                return vm.layoutImage.lastItem.progress > 0 ?
                    vm.layoutImage.lastItem.progress : 0;
            };

            fileUploader.filters.push({
                name: 'imageFilter',
                fn: function(item) {
                    var imageAllowedType = {
                        jpg: '', png: '', jpeg: '', bmp: '', gif: ''
                    };
                    var isAllowed = (imageAllowedType[item.type
                            .slice(item.type.lastIndexOf('/') + 1)] === '');

                    if (!isAllowed) {
                        toastr.warning("DEVICE.IMAGE_TYPE_NOT_SUPPORTED");
                    }

                    if (isAllowed) {
                        var maxLength = fileUploaderFactory.maxFileNameLength;
                        if (item.name.length > maxLength) {
                            $translate("DEVICE.FILE_NAME_TOO_LONG",
                                { length: maxLength }).then(function success(info) {
                                toastr.warning(info);
                            });
                            isAllowed =  false;
                        }
                    }

                    if (!isAllowed) {
                        if (angular.isArray(fileUploader.queue) &&
                            fileUploader.queue.length >= 1) {
                            fileUploader.queue.pop();
                        }
                        return false;
                    }
                    return true;
                }
            });
            return fileUploader;
        })(vm);

        $scope.$on('layoutImageLoadError', function(){
            toastr.error('DEVICE.ERROR_WHEN_LOAD_LAYOUT_IMAGE');
        });

        $scope.$on('boardDrawed', function(event, args) {
            function initPinsPosition(pins, ratio, dbRatio) {
                pins.forEach(function(pin) {
                    pin.x = pin.xPosition * dbRatio / ratio;
                    pin.y = pin.yPosition * dbRatio / ratio;
                });
            }

            vm.image = args;
            var ratio = getImageRatio();
            vm.promise = devicesService.getLayoutByModel(getDeviceModel())
                .then(function(response) {
                    var device = response.data, pins = device.devicePins;
                    var dbRatio = vm.image.realWidth/ device.deviceImageWidth;
                    if (dbRatio == Infinity) {
                        dbRatio = ratio;
                    }
                    var groupPins =[], viewPins = [];
                    pins.forEach(function(pin){
                        var gPin = pinsLayoutService.pinFromServer(pin);
                        groupPins.push(gPin);
                    });
                    groupPins.forEach(function(gPin) {
                        if (!gPin.pins) {
                            viewPins.push(gPin);
                        } else {
                            Array.prototype.push.apply(viewPins, gPin.pins);
                        }
                    });

                    initPinsPosition(viewPins, ratio, dbRatio);
                    vm.groupPins = groupPins;
                    vm.pins = viewPins;
                    if (vm.layoutImage.lastItem && !vm.layoutImage.lastItem.saved) {
                        // 为什么这里要save一下？
                        // 因为这样可以把最新的图片和布局信息保存到数据库，
                        // 避免数据库中没有图片宽高（或者是之前的图片宽高）导致显示异常
                        saveLayout(true);
                        vm.layoutImage.lastItem.saved = true;
                    }
                }, function(error) {
                    error.pop();
                });
        });

        function getImageRatio() {
            return vm.image.ratio;
        }

        function getDeviceId() {
            var id = vm.realDevice.id;
            return id;
        }

        function getDeviceModel() {
            var model = vm.realDevice.model;
            return model;
        }

        pinsLayoutService.onLayout($scope, function(event, data) {
            var deviceController = data.deviceController, realDevice = data.realDevice;
            vm.deviceController = deviceController;
            var device = vm.device = deviceController.device;
            vm.realDevice = realDevice;
            vm.layoutImage = {
                imageSrc: pinsLayoutService.urlOfLayoutImage(getDeviceModel())
            };

            vm.imageUploader.url = pinsLayoutService.urlOfLayoutImageUploader(getDeviceModel());
            if (device.uploadImage) {
                vm.imageUploaded = true;
                vm.layoutImage.lastItem = {
                    saved: true,
                    imageSrc: vm.layoutImage.imageSrc
                };
            }
        });

        pinsLayoutService.onTemplate($scope, function(event, template) {
            vm.dataBus = {}; var dataBus, i, bus;
            dataBus = angular.copy(template.dataBus);
            for (i = 0; i < dataBus.length; i++) {
                bus = dataBus[i]; bus.io = "IN";
            }
            vm.dataBus.in = dataBus;

            dataBus = angular.copy(template.dataBus);
            for (i = 0; i < dataBus.length; i++) {
                bus = dataBus[i]; bus.io = "OUT";
            }
            vm.dataBus.out = dataBus;
        });

        vm.skipToNext = function() {
            vm.deviceController.otherFilesLocked = false;
            vm.deviceController.selectedTab += 1;
            vm.deviceController.layoutLocked = true;
        };

        // {boolean} auto 自动保存，true表示上传图片后自动保存，false表示用户点击按钮触发的保存
        function saveLayout(auto) {
            var layout = {
                deviceImageHeight: vm.image.height,
                deviceImageWidth: vm.image.width,
                deviceId: getDeviceId(),
                devicePins: []
            };

            function checkPins(pins) {
                var names = Object.create(null), invalidatedName, name;
                for (var pin_i = 0; pin_i < pins.length; pin_i++) {
                    var pin = pins[pin_i];
                    name = pin.pin; if (!name) {
                        toastr.error("DEVICE.MESSAGE_PIN_NAME_IS_EMPTY");
                        return false;
                    }
                    if (names[name]) {
                        invalidatedName = name;
                        break;
                    } else {
                        names[name] = name;
                    }
                }

                if (invalidatedName) {
                    $translate("DEVICE.PIN_ALREADY_EXIST", { name: invalidatedName }).then(function success(info) {
                        toastr.error(info);
                    });
                    return false;
                }

                return true;
            }

            var check = checkPins(vm.groupPins);
            if (check) {
                var pins = [];
                vm.groupPins.forEach(function(groupPin){
                    var p = pinsLayoutService.pinToServer(groupPin);
                    pins.push(p);
                });
                layout.devicePins = pins;

                vm.promise = devicesService.saveBoardLayout(layout)
                .then(function() {
                    if (vm.deviceController.edit !== true && !auto) {
                        vm.skipToNext();
                    }
                    !auto && toastr.success("DEVICE.SAVE_LAYOUT_SUCCESS");
                }, function(error) {
                    error.pop();
                });
            }
        }

        function onDrop($event, $data) {
            if ($data.pin) {
                updatePin($event, $data);
            } else {
                addPin($event, $data)
            }

            function dropXy($event) {
                var rect = document.getElementById('board').getBoundingClientRect();
                var newX = $event.offsetX, newY = $event.offsetY;
                return {
                    x: newX - (lastEventOffset.x - 5),
                    y: newY - (lastEventOffset.y - 5)
                };
            }

            function updatePin($event, $data) {
                var pin = $data.pin, newXY = dropXy($event),
                    newX = newXY.x, newY = newXY.y;
                for (var i = vm.pins.length - 1; i >= 0; i--) {
                    if (vm.pins[i].pin === pin) {
                        updatePinXy(vm.pins[i], newX, newY);
                        break;
                    }
                }
            }

            function updatePinXy(pin, newX, newY) {
                var ratio = getImageRatio();
                pin.x = newX;
                pin.y = newY;
                pin.xPosition = newX * ratio;
                pin.yPosition = newY * ratio;
            }

            function addPin($event, $data) {
                function newName(name) {
                    var i = 0, size = vm.pins.length, newName;
                    for (i; i < size + 1; i++) {
                        newName = name.toLowerCase()
                        if (i > 0) {
                            newName = newName + "-" + i;
                        }
                        if (!pinService.existPin(newName)) {
                            return newName;
                        }
                    }
                }

                var pinConfig = {
                    deviceId: getDeviceId(), pin: newName($data.code),
                    pinCategoryCode: $data.code, pinCategoryName: $data.name,
                    xPosition: 0, yPosition: 0,
                    metaData: {
                        v: "1", io: $data.io
                    }
                }, pin;

                if (pinConfig.pinCategoryName === "I2C") {
                    pinConfig.metaData.pins = [{
                        "pin":"SDA", x: 0, y: 0
                    }, {
                        "pin":"SCL", x: 0, y: 0
                    }];

                    pin = pinsLayoutService.pinFromServer(pinConfig);
                    Array.prototype.push.apply(vm.pins, pin.pins);

                    var newXY = dropXy($event);
                    updatePinXy(pin.pins[0], newXY.x - 7, newXY.y);
                    updatePinXy(pin.pins[1], newXY.x + 7, newXY.y);
                    vm.groupPins.push(pin);
                } else if (pinConfig.pinCategoryName === "UART") {
                    pinConfig.metaData.pins = [{
                        "pin":"RX", x: 0, y: 0
                    }, {
                        "pin":"TX", x: 0, y: 0
                    }];

                    pin = pinsLayoutService.pinFromServer(pinConfig);
                    Array.prototype.push.apply(vm.pins, pin.pins);

                    var newXY = dropXy($event);
                    updatePinXy(pin.pins[0], newXY.x - 7, newXY.y);
                    updatePinXy(pin.pins[1], newXY.x + 7, newXY.y);
                    vm.groupPins.push(pin);
                } else if (pinConfig.pinCategoryName === 'UART-HWFC') {
                    pinConfig.metaData.pins = [{
                        "pin":"RX", x: 0, y: 0
                    }, {
                        "pin":"TX", x: 0, y: 0
                    }, {
                        "pin":"CTS", x: 0, y: 0
                    }, {
                        "pin":"RTS", x: 0, y: 0
                    }];

                    pin = pinsLayoutService.pinFromServer(pinConfig);
                    Array.prototype.push.apply(vm.pins, pin.pins);

                    var newXY = dropXy($event);
                    updatePinXy(pin.pins[0], newXY.x - 7, newXY.y - 7);
                    updatePinXy(pin.pins[1], newXY.x + 7, newXY.y - 7);
                    updatePinXy(pin.pins[2], newXY.x - 7, newXY.y + 7);
                    updatePinXy(pin.pins[3], newXY.x + 7, newXY.y + 7);
                    vm.groupPins.push(pin);
                } else if (pinConfig.pinCategoryName === 'QEI') {
                    pinConfig.metaData.pins = [{
                        "pin":"IDX", x: 0, y: 0
                    }, {
                        "pin":"PHA", x: 0, y: 0
                    }, {
                        "pin":"PHB", x: 0, y: 0
                    }];

                    pin = pinsLayoutService.pinFromServer(pinConfig);
                    Array.prototype.push.apply(vm.pins, pin.pins);

                    var newXY = dropXy($event);
                    updatePinXy(pin.pins[0], newXY.x, newXY.y - 6);
                    updatePinXy(pin.pins[1], newXY.x + 6, newXY.y + 6);
                    updatePinXy(pin.pins[2], newXY.x - 6, newXY.y + 6);
                    vm.groupPins.push(pin);
                } else if (pinConfig.pinCategoryName === 'RS485') {
                    pinConfig.metaData.pins = [{
                        "pin":"A", x: 0, y: 0
                    }, {
                        "pin":"B", x: 0, y: 0
                    }];

                    pin = pinsLayoutService.pinFromServer(pinConfig);
                    Array.prototype.push.apply(vm.pins, pin.pins);

                    var newXY = dropXy($event);
                    updatePinXy(pin.pins[0], newXY.x - 7, newXY.y);
                    updatePinXy(pin.pins[1], newXY.x + 7, newXY.y);
                    vm.groupPins.push(pin);
                } else {
                    pin = pinsLayoutService.pinFromServer(pinConfig);

                    vm.pins.push(pin);
                    vm.groupPins.push(pin);
                    updatePin($event, pin);

                    toastr.success("DEVICE.ADD_PIN_SUCCESS");
                }
            }
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('DeviceCreateController', DeviceCreateController);

    /** @ngInject */
    function DeviceCreateController(devicesService,
        toastr, pinsLayoutService) {
        var vm = this;

        activate();

        function activate() {
            vm.layoutLocked = true;
            vm.otherFilesLocked = true;
            vm.detailInfoLocked = true;
            vm.driversLocked = true;
            vm.device = {
                keyWords: []
            };
            getDeviceTemplate();
        }

        vm.createDevice = function() {
            if (vm.device.hasMultipleVoltage) {
                vm.device.singleWorkingVoltage = '';
            } else {
                vm.device.multipleWorkingVoltage = '';
            }

            vm.promise = devicesService.createDevice(vm.device)
                .then(function(response) {

                    vm.uploaderDevice = response.data;
                    vm.layoutLocked = false;
                    vm.infoLocked = true;
                    vm.selectedTab += 1;

                    var uploaderDevice = angular.copy(response.data);
                    pinsLayoutService.broadcastLayout(vm, uploaderDevice);
                    toastr.success("DEVICE.CREATE_SUCCESS");
                }, function(error) {
                    error.pop();
                });
        };

        function getDeviceTemplate() {
            vm.promise = devicesService.getDeviceTemplate()
                .then(function(response) {
                    vm.template = response.data;
                    pinsLayoutService.broadcastTemplate(vm.template);
                }, function(error) {
                    error.pop();
                });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('DeviceCreateBindingController',
            DeviceCreateBindingController);

    /** @ngInject */
    function DeviceCreateBindingController(devicesService, toastr,
        rapsService, pinsLayoutService, $state, $scope) {
        var vm = this;
        vm.querySearch = function (query) {
            query = query || '';
            return rapsService.searchDrivers(query)
                .then(function(response) {
                    return response.data.raps;
                }, function() {});
        };

        vm.selectedItemChange = function (item) {
            if (!item) {
                return;
            }

            if (!isRapExist(vm, item)) {
                addRap(vm, item);
                vm.searchText = null;
            }
        };

        vm.selectedRaps = [];

        function addRap(vm, rap) {
            vm.selectedRaps.push(rap);
        }

        function isRapExist(vm, rap) {
            return vm.selectedRaps.some(function(value) {
                if (value.name === rap.name && value.version == rap.version) {
                    return true;
                }
            });
        }

        vm.rapVersions = {};
        vm.loadVersion = function (rapName) {
            if (vm.rapVersions[rapName]) {
                return;
            }
            vm.rapVersions[rapName] = {
                versions: []
            };

            rapsService.searchDriversAccurately(rapName).then(function(response) {
                response.data.raps.forEach(function(rap) {
                    vm.rapVersions[rapName].versions.push(
                        rap.version);
                });
            }, function() {});
        };

        vm.removeSelectedRap = function (rap) {
            vm.selectedRaps = vm.selectedRaps.filter(function(el) {
                return el.name !== rap.name || el.version !== rap.version;
            });

            vm.searchText = null;
        };

        vm.create = function () {
            if (!vm.selectedRaps.length) {
                vm.gotoShowDevicePage();
                return;
            }

            vm.update(function () {
                vm.gotoShowDevicePage();
            });
        };
        vm.skipToNext = function () {
            vm.gotoShowDevicePage();
        };
        vm.update = function (fn) {
            var bindings = [];
            vm.selectedRaps.forEach(function(rap) {
                bindings.push({
                    rapName: rap.name,
                    rapVersion: rap.version
                });
            });

            devicesService.bindToDevice(vm.device.model, bindings).then(function() {
                toastr.success('DEVICE.BIND_SUCCESS');
                if (fn) {
                    fn();
                }
            }, function(error) {
                error.pop();
            });
        };

        vm.cancel = function () {
            vm.selectedRaps = angular.copy(originalRaps);
        };

        vm.device = {};
        var originalRaps = [];
        pinsLayoutService.onLayout($scope, function(event, data) {
            vm.device = data.realDevice;
            if (vm.device.drivers) {
                vm.device.drivers.forEach(function(rap) {
                    addRap(vm, rap);
                });
                originalRaps = angular.copy(vm.selectedRaps);
                return;
            }
        });

        vm.goToDetailPage = function (rapName) {
            $state.go('raps.show', {
                name: rapName
            });
        };

        vm.gotoShowDevicePage = function () {
            $state.go('devices.show', {
                model: vm.device.model
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('grootRpm').directive('userBar', userBar);
    /** @ngInject */
    function userBar() {
        return {
            templateUrl: 'app/components/user-bar/user-bar.html',
            controller: userBarController,
            controllerAs: 'userBar'
        }
        /** @ngInject */
        function userBarController(authenticationService, $scope, toastr,
            $state, broadcastService) {
            var vm = this;

            if (authenticationService.isAuthenticated()) {
                doLogin();
            }

            vm.logout = function() {
                authenticationService.logout();
                vm.loggedIn = false;
                broadcastService.send('logoutEvent');
                var loc = window.location;
                var url = loc.protocol + '//' + loc.host
                    + '/sso/logoutUrl';
                window.location = url;
            };

            $scope.$on('loginEvent', doLogin);

            function doLogin() {
                vm.loggedIn = true;
                vm.username = authenticationService.getUser().name;
            }
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('grootRpm')
		.directive('randomAvatar', avatar);

	/** @ngInject */
	function avatar() {


		/* Configuration variables */
		var MAX_COLOR = 200; // Max value for a color component
		var MIN_COLOR = 120; // Min value for a color component
		var FILL_CHANCE = 0.5; // Chance of a square being filled [0, 1]
		var SQUARE = 80; // Size of a grid square in pixels
		var GRID = 5; // Number of squares width and height
		var PADDING = SQUARE / 2; // Padding on the edge of the canvas in px
		var SIZE = SQUARE * GRID + PADDING * 2; // Size of the canvas
		var FILL_COLOR = '#F0ECE6'; // canvas background color

		return {
			restrict: 'E',
			template: '<img class="pull-left"/>',
			link: function(scope, element, attributes) {
				// var seed = scope.$eval(attributes.seed);
				var seed = attributes.seed;

				var random = new Math.seedrandom('seed:' + seed);

				var urlDataImage = generateIdenticon(); // Generate identicon
				var image = element.find('img');
				image[0].src = urlDataImage; // Assign url data to image

				/* Create a temporary canvas */
				function setupCanvas() {
					var canvas = document.createElement('canvas');
					canvas.width = SIZE;
					canvas.height = SIZE;

					// Fill canvas background
					var context = canvas.getContext('2d');
					context.beginPath();
					context.rect(0, 0, SIZE, SIZE);
					context.fillStyle = FILL_COLOR;
					context.fill();
					return canvas;
				}

				/* Fill in a square of the canvas */
				function fillBlock(x, y, color, context) {
					context.beginPath();
					context.rect(PADDING + x * SQUARE, PADDING + y * SQUARE, SQUARE, SQUARE);
					context.fillStyle = 'rgb(' + color.join(',') + ')';
					context.fill();
				}

				/* Generate a random color with low saturation. */
				function generateColor() {
					var rgb = [];
					for (var i = 0; i < 3; i++) {
						var val = Math.floor(MIN_COLOR + random() * (MAX_COLOR - MIN_COLOR));
						rgb.push(val);
					}
					return rgb;
				}

				/* Generate a random identicon */
				function generateIdenticon() {
					var canvas = setupCanvas();
					var context = canvas.getContext('2d');
					var color = generateColor(); // Generate custom tile color

					// Iterate through squares on left side
					for (var x = 0; x < Math.ceil(GRID / 2); x++) {
						for (var y = 0; y < GRID; y++) {
							// Randomly fill squares
							if (random() < FILL_CHANCE) {
								fillBlock(x, y, color, context);

								// Fill right side symmetrically
								if (x < Math.floor(GRID / 2)) {
									fillBlock((GRID - 1) - x, y, color, context);
								}
							}
						}
					}
					return canvas.toDataURL();
				}
			}
		};

	}

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('search', search);

    /** @ngInject */
    function search(authenticationService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/search/search.html',
            controller: SearchController,
            controllerAs: 'search',
            bindToController: true
        };


        return directive;

        /** @ngInject */
        function SearchController($window, devicesService, rapsService, $q,
            $state) {
            var vm = this;

            if (authenticationService.isAuthenticated()) {
                vm.loggedIn = true;
                vm.username = authenticationService.getUser().name;
            }
            vm.search = function() {
                $state.go('search', {
                    keyword: vm.text
                });
            };
            vm.logout = function() {
                authenticationService.logout();
                $window.location.reload();
            };
            vm.querySearch = function(keyword) {
                keyword = keyword || '';

                var results = [];
                var devicePromise = devicesService.searchDevices(
                        keyword)
                    .then(function(response) {
                        results = results.concat(response.data.devices);
                    }, function() {});
                var rapPromise = rapsService.searchRaps(keyword)
                    .then(function(response) {
                        results = results.concat(response.data.raps);
                    }, function() {});

                return $q.all([devicePromise, rapPromise]).then(
                    function() {
                        return results;
                    },
                    function() {});
            };
            vm.goToDetailPage = function(item) {
                if (item) {
                    vm.text = '';
                    if (item.model) {
                        $state.go('devices.show', {
                            model: item.model
                        });
                    } else {
                        $state.go('raps.show', {
                            name: item.name
                        });
                    }
                }
            };
            vm.closeDropdownAndSearch = function() {
                var autoChild = document.getElementById('mainSearch').firstElementChild;
                var el = angular.element(autoChild);
                el.scope().$mdAutocompleteCtrl.hidden = true;
                vm.search();
            };
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('acmeNavBar', acmeNavBar);

    /** @ngInject */
    function acmeNavBar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            controller: NavBarController,
            controllerAs: 'navBar',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavBarController(authenticationService, $scope) {
            var vm = this;
            init();
            $scope.$on('loginEvent', init);
            $scope.$on('logoutEvent', init);
            function init() {
                vm.show = authenticationService.isAuthenticated();
                vm.user = authenticationService.getUser();
            }
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('acmeMalarkey', acmeMalarkey);

    /** @ngInject */
    function acmeMalarkey(malarkey) {
        var directive = {
            restrict: 'E',
            scope: {
                extraValues: '='
            },
            template: '&nbsp;',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el) {
            var typist = malarkey(el[0], {
                typeSpeed: 40,
                deleteSpeed: 40,
                pauseDelay: 800,
                loop: false,
                postfix: ' '
            });

            el.addClass('acme-malarkey');
            for (var i = 0; i < scope.extraValues.length - 1; i++) {
                typist.type(scope.extraValues[i]).pause().delete();
            }
            typist.type(scope.extraValues[scope.extraValues.length - 1]).pause();
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('translateLink', translate);

    /** @ngInject */
    function translate($localStorage) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/i18n/translate.directive.html',
            controller: translateController,
            controllerAs: 'translateLink',
            bindToController: true
        };


        return directive;

        /** @ngInject */
        function translateController($translate, $scope, momentLangService) {
            $scope.lang = $localStorage.lang ?
                $localStorage.lang : $translate.preferredLanguage();
            $scope.changeLanguage = function(langKey) {
                $translate.use(langKey);
                $scope.lang = langKey;
                $localStorage.lang = langKey;
                momentLangService.setLang();
            };
        }
    }

})();
(function() {
    'use strict';

    angular.module('grootRpm').directive('customHeader', function() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/header/header.html'
        };
    });
})();

(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('usernameAvailable', usernameAvailable);

    /** @ngInject */
    function usernameAvailable(userService, $q) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attr, ngModel) {
                ngModel.$asyncValidators.usernameOccupied = function(
                    viewValue) {
                    scope.auth.waiting = true;
                    var deferred = $q.defer();
                    userService.isUsernameAvailable(viewValue)
                        .then(function(response) {
                            scope.auth.waiting = false;
                            if (response.data.exist) {
                                deferred.reject();
                            } else {
                                deferred.resolve();
                            }
                        }, function() {
                            scope.auth.waiting = false;

                        });
                    return deferred.promise;
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('pinnameAvailable', pinnameAvailable);

    /** @ngInject */
	function pinnameAvailable(userService, $q) {
		return {
			require: 'ngModel',
			link: function(scope, elm, attr, ngModel) {
				ngModel.$validators.pinnameAvailable = function(pinname){
					if (!pinname) return false;
					var a = encodeURIComponent(pinname) === pinname && !/\./.test(pinname);
					return a;
				};
			}
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('passwordMatchCheck', passwordMatchCheck);

    /** @ngInject */
    function passwordMatchCheck() {
        return {
            require: 'ngModel',
            scope: {
                otherModelValue: '=passwordMatchCheck'
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.passwordMatch = function(viewValue) {
                    return viewValue === scope.otherModelValue;
                };

                scope.$watch('otherModelValue', function() {
                    ngModel.$validate();
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .directive('emailAvailable', emailAvailable);

    /** @ngInject */
    function emailAvailable(userService, $q) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attr, ngModel) {
                ngModel.$asyncValidators.usernameOccupied = function(
                    viewValue) {
                    scope.auth.waiting = true;
                    var deferred = $q.defer();
                    userService.isEmailAvailable(viewValue)
                        .then(function(response) {
                            scope.auth.waiting = false;
                            if (response.data.exist) {
                                deferred.reject();
                            } else {
                                deferred.resolve();
                            }
                        }, function() {
                            scope.auth.waiting = false;

                        });
                    return deferred.promise;
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('grootRpm').directive('boardShow', boardShow);

    /** @ngInject */
    function boardShow($window, pinsLayoutService) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D)
        };

        return {
            restrict: 'A',
            templateUrl: 'app/components/board-show/board-show.html',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                scope.$watch(attributes.boardShow, function(params) {
                    var imageSrc = params.imageSrc;
                    var parentWidth = document.getElementById('imageCanvas').clientWidth;
                    if (imageSrc) {
                        pinsLayoutService.displayImage(null, {
                            src: imageSrc, maxWidth: parentWidth
                        });
                    }
                });
            }
        };

    }

})();
(function() {
    'use strict';

    angular.module('grootRpm').directive('board', board);

    /** @ngInject */
    function board($window, pinsLayoutService) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window
                    .File;
            },
            isImage: function(file) {
                var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            templateUrl: 'app/components/board/board.html',
            link: function(scope, element, attributes) {
                if (!helper.support) return;
                var board, display = function(event, imageSrc) {
                    var parentWidth = document.getElementById('imageCanvas').clientWidth;
                    return pinsLayoutService.displayImage(event, {
                        src: imageSrc, maxWidth: parentWidth
                    });
                }

                scope.$watch(attributes.board, function(params) {
                    if (params === undefined || params.saved === undefined) return;
                    var file = params.file, imageSrc = params.imageSrc;
                    board = document.getElementById('board');

                    if (file) {
                        if (!helper.isFile(file)) return;
                        if (!helper.isImage(file)) return;
                        var reader = new FileReader();
                        reader.onload = display;
                        reader.readAsDataURL(file);
                    }
                    if (imageSrc) {
                        display(null, imageSrc);
                    }
                });
            }
        };

    }

})();
(function() {
	'use strict';

	angular.module('grootRpm')
		.service('userService', userService);

	/** @ngInject */
	function userService(ApiBaseUrl, $http) {
		this.login = function(user) {
            if (isEmail(user.name)) {
				user.email = user.name;
				user.name = '';
			}
			return $http.post(ApiBaseUrl + 'user/login', user);
		};
		this.signup = function(user) {
			return $http.post(ApiBaseUrl + 'user/signupWithEmail', user);
		};
		this.isUsernameAvailable = function(username) {
			return $http.get(ApiBaseUrl + 'user/name?name=' + username);
		};
		this.isEmailAvailable = function(email) {
			return $http.get(ApiBaseUrl + 'user/email?email=' + email);
		};
		this.getUser = function(userName) {
			return $http.get(ApiBaseUrl + 'user/name/' + userName);
		};

		/**
		 * [05/12/2016] Added by Gary Yuan
		 * @describe Account system has been refactor for bbs & rap single sign on, and modify is also needed here.
		 * @param ssoObj {Object} the sso information got from sso server
		 * @param ssoObj.sso {String}
		 * @param ssoObj.sig {String}
		 */
		this.loginWithSSO = function(ssoObj) {
			return $http.post(ApiBaseUrl + 'sso/login', ssoObj)
		}
	}

	function isEmail(email) {
		return email.indexOf("@") > -1;
	}
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('UserHomeController', UserHomeController);

    /** @ngInject */
    function UserHomeController(devicesService, rapsService,
        $stateParams, $q, $localStorage, userService, $state, moment) {

        var vm = this;
        var username = $stateParams.username;
        vm.user = $localStorage.user;
        vm.isSelf = vm.user ? vm.user.name == username : false;
        activate();

        function activate() {
            vm.promise = $q.all([
                devicesService.getDevicesByUserName(username),
                rapsService.getRapsByUsername(username),
                userService.getUser(username)
            ]).then(function(responses) {
                    vm.devices = responses[0].data;
                    vm.raps = responses[1].data;
                    vm.userProfile = responses[2].data;
                })
                .then(null, function(error) {
                    if (error.isNotFound()) {
                        $state.go('404');
                    } else {
                        error.pop();
                    }
                });
        }
    }
})();
(function() {
	'use strict';

	angular.module('grootRpm')
		.service('authenticationService', authenticationService);

	/** @ngInject */
	function authenticationService($localStorage, broadcastService) {

		var _authenticated = false;

		this.login = function(user, token) {
			$localStorage.user = user;
			$localStorage.token = token;
			_authenticated = true;
			broadcastService.send('loginEvent');
		};
		this.isAuthenticated = function() {
			if ($localStorage.user && $localStorage.token) {
				_authenticated = true;
			}
			return _authenticated;
		};
		this.logout = function() {
			$localStorage.$reset();
			_authenticated = false;
		};

		this.getUser = function() {
			return $localStorage.user;
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('AuthenticationController', AuthenticationController);

    /** @ngInject */
    function AuthenticationController($state, authenticationService,
        userService, toastr, $location) {
        var vm = this;

        activate();

        function activate() {
            var ssoObject = $location.search();

            if (ssoObject.sso && ssoObject.sig) {
                return userService.loginWithSSO(ssoObject)
                    .then(function(response){
                        toastr.success('SUCCESSFULLY_LOGGED_IN');
                        doLogin(response)
                    }, function(error) {
                        error.pop()
                    })

            } else {
                toastr.error('PARAM_IS_MISSING')
            }


        }

        //vm.login = function() {
        //    vm.promise = userService.login(vm.user)
        //        .then(function(response) {
        //            toastr.success('SUCCESSFULLY_LOGGED_IN');
        //            doLogin(response);
        //        }, function(error) {
        //            error.pop();
        //        });
        //};
        //
        //vm.signup = function() {
        //    vm.promise = userService.signup(vm.user)
        //        .then(function(response) {
        //            toastr.success('SUCCESSFULLY_CREATE_ACCOUNT');
        //            doLogin(response);
        //        }, function(error) {
        //            error.pop();
        //        });
        //};


        function doLogin(response) {
            var user = {
                id: response.headers('user_id'),
                name: response.headers('user_name'),
                email: response.headers('user_email')
            };
            authenticationService.login(user, response.headers(
                'access_token'));
            $state.go('user-home', {
                username: user.name
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .service('rapsService', rapsService);

    /** @ngInject */
    function rapsService(ApiBaseUrl, $http) {
        this.searchRaps = function(keyword) {
            return $http.get(ApiBaseUrl + 'raps?name=' + keyword);
        };
        this.searchRapsAccurately = function(keyword) {
            return $http.get(ApiBaseUrl + 'raps?name=' + keyword +
                '&accurately=true');
        };
        this.pageRaps = function (pageIndex, limit) {
            return $http.get(ApiBaseUrl + 'raps?pageIndex=' + pageIndex + '&limit=' + limit);
        };
        this.searchDrivers = function (name) {
            return $http.get(ApiBaseUrl + 'raps?name=' + name +
                '&driver=true');
        };
        this.searchDriversAccurately = function (name) {
            return $http.get(ApiBaseUrl + 'raps?name=' + name +
                '&driver=true&accurately=true');
        };
        this.getRapsByUsername = function(username) {
            return $http.get(ApiBaseUrl + 'users/' + username + '/raps');
        };
        this.getRapByName = function(name) {
            return $http.get(ApiBaseUrl + 'raps/' + name + '/latest');
        };
        this.getRapsByName = function(name) {
            return $http.get(ApiBaseUrl + 'raps/' + name);
        };
        this.getLatestRapByName = function(name) {
            return $http.get(ApiBaseUrl + 'raps/' + name + '/latest');
        };
        this.getTopDownloadRaps = function(topN) {
            return $http.get(ApiBaseUrl +
                'statistics/rap/maxDownloads?limit=' + topN);
        };
        this.getRecentlyUpdatedRaps = function(limit) {
            return $http.get(ApiBaseUrl +
                'statistics/rap/latestCreated?limit=' + limit);
        };
        this.getRapStatisticsByName = function(name) {
            return $http.get(ApiBaseUrl + 'statistics/rap/name/' + name)
        };
        this.getRapTotalAmount = function() {
            return $http.get(ApiBaseUrl + 'statistics/rap/totalAmount')
        };
        this.getRapTotalDownloadTimes = function() {
            return $http.get(ApiBaseUrl +
                'statistics/rap/totalDownloadTimes')
        };
        this.getRapSupportedDevices = function(name) {
            return $http.get(ApiBaseUrl + 'raps/' + name + '/latest/devices');
        };
        this.getReadme = function(name) {
            return $http({
                url: ApiBaseUrl + 'raps/' + name + '/latest/readme',
                method: 'GET',
                headers: {
                    'Content-Type': '*/*'
                },
                transformResponse: [function(data) {
                    try {
                        return angular.fromJson(data);
                    } catch (err) {
                        return data;
                    }
                }]
            });
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('RapShowController', RapShowController);

    /** @ngInject */
    function RapShowController($stateParams, rapsService, $state, $q,
        moment) {
        var vm = this;

        vm.goToDetailPage = goToDetailPage;

        activate();

        function activate() {
            var name = $stateParams.name;
            vm.promise = rapsService.getRapByName(name)
                .then(function(response) {
                    vm.rap = response.data;
                    vm.createTime = moment(vm.rap.createTime).startOf('second').fromNow();
                    return $q.all([
                        rapsService.getRapStatisticsByName(vm.rap.name),
                        rapsService.getRapSupportedDevices(vm.rap.name),
                        rapsService.getRapsByName(vm.rap.name),
                        rapsService.getLatestRapByName(vm.rap.name),
                        getReadmePromise()
                    ]).then(function(responses) {
                        vm.statistics = responses[0].data;
                        vm.supportedDevices = responses[1].data;
                        vm.releasedCount = responses[2].data.raps.length;
                        vm.latestRap = responses[3].data;
                        vm.isLatestVersion = vm.latestRap.version == vm.rap.version;
                    }, function(error) {
                        error.pop();
                    });
                }, function(error) {
                    if (error.isNotFound()) {
                        $state.go('404');
                    } else {
                        error.pop();
                    }
                });
        }

        function goToDetailPage(model) {
            $state.go('devices.show', {
                model: model
            });
        }

        function getReadmePromise() {
            rapsService.getReadme(vm.rap.name)
                .then(function(response) {
                    vm.rap.readme = response.data;
                });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('grootRpm')
        .controller('RapListController', RapListController);

    /** @ngInject */
    function RapListController(rapsService) {
        var vm = this;

        vm.pageRecords = {
            pageIndex: 1
        };

        vm.limit = 10;

        vm.gotoPage = function () {
            rapsService.pageRaps(vm.pageRecords.pageIndex, vm.limit).then(function(raps) {
                vm.pageRecords = raps.data;
            }, function(error) {
                error.pop();
            });
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController($stateParams, devicesService,
        rapsService, $q) {
        var vm = this;

        activate();

        function activate() {

            var keyword = $stateParams.keyword || '';
            vm.keyword = keyword;

            vm.devicePromise = devicesService.searchDevices(keyword)
                .then(function(response) {
                    vm.devices = response.data.devices;

                }, function(error) {
                    error.pop();
                });
            vm.rapPromise = rapsService.searchRaps(keyword)
                .then(function(response) {
                    vm.raps = response.data.raps;

                }, function(error) {
                    error.pop();
                });

            vm.promise = $q.all([vm.devicePromise, vm.rapPromise]);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(rapsService, devicesService, $q) {
        var vm = this;
        activate();

        function activate() {
            vm.promise = $q.all([
                rapsService.getTopDownloadRaps(6),
                rapsService.getRecentlyUpdatedRaps(6),
                devicesService.getRecentlyUpdatedDevices(6),
                rapsService.getRapTotalDownloadTimes(),
                rapsService.getRapTotalAmount(),
                devicesService.getDeviceTotalAmount()
            ]).then(function(responses) {
                vm.topDownloadRaps = responses[0].data.maxDownloads;
                vm.recentlyUpdatedRaps = responses[1].data.raps;
                vm.recentlyUpdatedDevices = responses[2].data.devices;
                vm.rapTotalDownloadTimes = responses[3].data.totalDownloadTimes;
                vm.rapTotalAmount = responses[4].data.totalAmount;
                vm.deviceTotalAmount = responses[5].data.totalAmount;
            }).then(null, function(error) {
                error.pop();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .config(translateProvider);

    /** @ngInject */
    function translateProvider($translateProvider) {
        $translateProvider.useStaticFilesLoader({
            prefix: '/assets/translate/',
            suffix: '.json'
        });

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.preferredLanguage('zh');

    }
})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .factory('momentLangService', momentLangService);

    /** @ngInject */
    function momentLangService($localStorage, moment) {
        return {
            setLang: function() {
                if ($localStorage.lang) {
                    moment.locale($localStorage.lang == 'en' ? 'en' : 'zh-cn');
                }
            }
        }
    }
})();
angular.module('grootRpm.environments', [])
.constant('ApiBaseUrl', "api/")
.constant('ImageBaseUrl', "api/");

(function(){
	'use strict';

    angular.module('grootRpm').service('pinsService', pinsService);

    var uniqueId = 0;
    function Pin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
        this._uniqueId = ++uniqueId;
        this.deviceId = deviceId;
        this.pin = name;

        this.pinCategoryCode = pinCategoryCode;
        this.pinCategoryName = pinCategoryName;
        // 数据库存储的坐标
        this.xPosition = 0; this.yPosition = 0;
        // 在图片上显示的坐标
        this.x; this.y;

        // 来自meta_data
        this.io = io; // IN | OUT
        this.pins;
    }

    Pin.getAttrId = function(pin) {
        return "PIN_" + pin._uniqueId;
    };
    Pin.prototype.getAttrId = function() {
        return Pin.getAttrId.call(this, this);
    };
    Pin.prototype.getCssClass = function() {
        if (this.io === "IN") return "pin pin-io-in";
        if (this.io === "OUT") return "pin pin-io-out";
        return "pin";
    };
    Pin.prototype.changeName = function() {
        var selfPin = this.pin;
        this.pins && this.pins.forEach(function(pin){
            pin.pin = selfPin + "." + pin._pin;
        });
    };
	Pin.prototype.buildFromServer = function(pin) {
		this.xPosition = pin.xPosition;
		this.yPosition = pin.yPosition;
		var metaData = pin.metaData;
		if (metaData) {
			if (angular.isString(metaData)) {
				metaData = JSON.parse(metaData);
			}
			this.metaData = metaData;
			this.io = this.metaData.io;
		}
	};
	Pin.prototype.toServer = function(pin) {
		var p = {
			deviceId: pin.deviceId,
			pin: pin.pin,
			pinCategoryCode: pin.pinCategoryCode,
			pinCategoryName: pin.pinCategoryName,
			metaData: {
				io: pin.io
			}
		};
		if (pin.x) {
			p.xPosition = parseFloat(pin.x.toFixed(2));
		}
		if (pin.y) {
			p.yPosition = parseFloat(pin.y.toFixed(2));
		}

		return p;
	}

	var PinTypes = {
		"I2C": "I2C",
		"UART": "UART",
		"UART-HWFC": "UART-HWFC",
		"QEI": "QEI",
		"RS485": "RS485"
	};

	// I2C Pin
	function I2CPin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
		Pin.apply(this, arguments);
	}
	I2CPin.prototype = Object.create(Pin.prototype);
	I2CPin.prototype.constructor = I2CPin;
	I2CPin.prototype.buildFromServer = function(pin) {
		Pin.prototype.buildFromServer.call(this, pin);
		var metaData = this.metaData, io = metaData.io, epin;
		var self = this;
		this.pins = metaData.pins.map(function(epin){
			var pin0 = new Pin(pin.deviceId, self.pin + "." + epin.pin,
				self.pinCategoryCode, self.pinCategoryName ,io);
			pin0.xPosition = epin.x;
			pin0.yPosition = epin.y;
			pin0._pin = epin.pin;
			return pin0;
		});
	};
	I2CPin.prototype.toServer = function(pin) {
		var v = Pin.prototype.toServer.call(this, pin);
		var pins = v.metaData.pins = [];
		pin.pins.forEach(function(ipin){
			var p = {
				pin: ipin._pin,
				x: parseFloat(ipin.x.toFixed(2)),
				y: parseFloat(ipin.y.toFixed(2))
			};
			pins.push(p);
		});
		return v;
	};

	// Uart Pin
	function UartPin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
		Pin.apply(this, arguments);
	}
	UartPin.prototype = Object.create(Pin.prototype);
	UartPin.prototype.constructor = UartPin;
	UartPin.prototype.buildFromServer = function(pin) {
		Pin.prototype.buildFromServer.call(this, pin);
		var metaData = this.metaData, io = metaData.io, epin;
		var self = this;
		this.pins = metaData.pins.map(function(epin){
			var pin0 = new Pin(pin.deviceId, self.pin + "." + epin.pin,
				self.pinCategoryCode, self.pinCategoryName ,io);
			pin0.xPosition = epin.x;
			pin0.yPosition = epin.y;
			pin0._pin = epin.pin;
			return pin0;
		});
	};
	UartPin.prototype.toServer = function(pin) {
		var v = Pin.prototype.toServer.call(this, pin);
		var pins = v.metaData.pins = [];
		pin.pins.forEach(function(ipin){
			var p = {
				pin: ipin._pin,
				x: parseFloat(ipin.x.toFixed(2)),
				y: parseFloat(ipin.y.toFixed(2))
			};
			pins.push(p);
		});
		return v;
	};

	// Uart Hardware flow control Pin
	function UartHwfcPin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
		Pin.apply(this, arguments);
	}
	UartHwfcPin.prototype = Object.create(Pin.prototype);
	UartHwfcPin.prototype.constructor = UartHwfcPin;
	UartHwfcPin.prototype.buildFromServer = function(pin) {
		Pin.prototype.buildFromServer.call(this, pin);
		var metaData = this.metaData, io = metaData.io, epin;
		var self = this;
		this.pins = metaData.pins.map(function(epin){
			var pin0 = new Pin(pin.deviceId, self.pin + "." + epin.pin,
				self.pinCategoryCode, self.pinCategoryName ,io);
			pin0.xPosition = epin.x;
			pin0.yPosition = epin.y;
			pin0._pin = epin.pin;
			return pin0;
		});
	};
	UartHwfcPin.prototype.toServer = function(pin) {
		var v = Pin.prototype.toServer.call(this, pin);
		var pins = v.metaData.pins = [];
		pin.pins.forEach(function(ipin){
			var p = {
				pin: ipin._pin,
				x: parseFloat(ipin.x.toFixed(2)),
				y: parseFloat(ipin.y.toFixed(2))
			};
			pins.push(p);
		});
		return v;
	};

	// QEI Pin
	function QEIPin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
		Pin.apply(this, arguments);
	}
	QEIPin.prototype = Object.create(Pin.prototype);
	QEIPin.prototype.constructor = QEIPin;
	QEIPin.prototype.buildFromServer = function(pin) {
		Pin.prototype.buildFromServer.call(this, pin);
		var metaData = this.metaData, io = metaData.io, epin;
		var self = this;
		this.pins = metaData.pins.map(function(epin){
			var pin0 = new Pin(pin.deviceId, self.pin + "." + epin.pin,
				self.pinCategoryCode, self.pinCategoryName ,io);
			pin0.xPosition = epin.x;
			pin0.yPosition = epin.y;
			if (epin.pin === 'IDX') {
				pin0.removable = true;
			}
			pin0._pin = epin.pin;
			return pin0;
		});
	};
	QEIPin.prototype.toServer = function(pin) {
		var v = Pin.prototype.toServer.call(this, pin);
		var pins = v.metaData.pins = [];
		pin.pins.forEach(function(ipin){
			var p = {
				pin: ipin._pin,
				x: parseFloat(ipin.x.toFixed(2)),
				y: parseFloat(ipin.y.toFixed(2))
			};
			pins.push(p);
		});
		return v;
	};

	// RS485 Pin
	function Rs485Pin(deviceId, name, pinCategoryCode, pinCategoryName, io) {
		Pin.apply(this, arguments);
	}
	Rs485Pin.prototype = Object.create(Pin.prototype);
	Rs485Pin.prototype.constructor = I2CPin;
	Rs485Pin.prototype.buildFromServer = function(pin) {
		Pin.prototype.buildFromServer.call(this, pin);
		var metaData = this.metaData, io = metaData.io, epin;
		var self = this;
		this.pins = metaData.pins ? metaData.pins.map(function(epin){
			var pin0 = new Pin(pin.deviceId, self.pin + "." + epin.pin,
				self.pinCategoryCode, self.pinCategoryName ,io);
			pin0.xPosition = epin.x;
			pin0.yPosition = epin.y;
			pin0._pin = epin.pin;
			return pin0;
		}) : [];
	};
	Rs485Pin.prototype.toServer = function(pin) {
		var v = Pin.prototype.toServer.call(this, pin);
		var pins = v.metaData.pins = [];
		pin.pins.forEach(function(ipin){
			var p = {
				pin: ipin._pin,
				x: parseFloat(ipin.x.toFixed(2)),
				y: parseFloat(ipin.y.toFixed(2))
			};
			pins.push(p);
		});
		return v;
	};

	/** @ngInject */
	function pinsService() {
		return {
			fromServer: function(pin) {
				var type = pin.pinCategoryName;
				var constructors = {
					"I2C": I2CPin,
					"UART": UartPin,
					"UART-HWFC": UartHwfcPin,
					"QEI": QEIPin,
					"RS485": Rs485Pin
				};
				
				var PinConstructor = constructors[type] || Pin;
				var p = new PinConstructor(pin.deviceId, pin.pin, pin.pinCategoryCode, pin.pinCategoryName, null);

				p.buildFromServer(pin);
				return p;
			},
			toServer: function(pin){
				var v = pin.toServer(pin);
				v.metaData = JSON.stringify(v.metaData);
				return v;
			}
		};
	}
})();
(function() {
    'use strict';

    angular.module('grootRpm').service('pinsLayoutService', pinsLayoutService);

    var colorCache = {}, rectLimit = {
        maxWidth: 500, maxHeight: 500
    }, events = {
        layoutAlready: "Layout_Already",
        templateAlready: "Template_Already"
    };

    /** @ngInject */
    function pinsLayoutService(ImageBaseUrl, ApiBaseUrl,
        broadcastService, pinsService) {
        return {
            pinFromServer: function(pin) {
                var p = pinsService.fromServer(pin);
                return p;
            },
            pinToServer: function(pin){
                var p = pinsService.toServer(pin);
                return p;
            },
            generateColor: function generateColor(seed) {
                var color = colorCache[String(seed)];
                if (color) {
                    return color;
                }
                var realSeed = "seed:fileupload-" + seed, random = new Math.seedrandom(realSeed),
                    hAry = [60, 120, 180, 240, 300, 360], sAry = ["50%", "60%", "70%", "80%", "90%", "100%"],
                    lAry = ["70%", "80%", "90%"];
                var hslAry = [hAry, sAry, lAry], i, ary, hsl = [];
                var orinum = Math.floor(random() * 100000), num = orinum, im;
                for (i = 0; i< 3; i++) {
                    ary = hslAry[i];
                    im = num % Math.pow(10, (5 - i * 2));
                    im = im % ary.length;
                    hsl.push(ary[im]);
                }

                color = "hsl(" + hsl.join(",") + ")";
                colorCache[String(seed)] = color;
                return color;
            },
            urlOfLayoutImage: function(model) {
                var url = ImageBaseUrl + 'devices/' + model + '/image?' + new Date().getTime();
                return url;
            },
            urlOfLayoutImageUploader: function(model) {
                var url = ApiBaseUrl + 'devices/' + model + '/image';
                return url;
            },
            displayImage: function(event, arg) {
                var img = new Image(), board = document.getElementById('board');
                var maxWidth = (arg.maxWidth || rectLimit.maxWidth) - 10;
                img.onload = function() {
                    var width, height, realWidth = this.width, realHeight = this.height,
                        maxHeight = rectLimit.maxHeight, ratio, widthRatio = realWidth/maxWidth,
                        heightRatio = realHeight/maxHeight;

                    if ((widthRatio > heightRatio) && (realWidth > maxWidth)) {
                        ratio = widthRatio; width = maxWidth;
                        height = realHeight / ratio;
                    } else if ((heightRatio > widthRatio) && (realHeight > maxHeight))  {
                        ratio = heightRatio; height = maxHeight;
                        width = realWidth / ratio;
                    } else {
                        ratio = 1; height = realHeight;
                        width = realWidth;
                    }

                    board.style.width = width + 'px';
                    board.style.height = height + 'px';
                    board.style['background-image'] = 'url(' + this.src + ')';
                    board.style['background-size'] = 'contain';
                    board.style['background-repeat'] = 'no-repeat';

                    broadcastService.send('boardDrawed', {
                        width: width,
                        height: height,
                        ratio: ratio,
                        realWidth: realWidth,
                        realHeight: realHeight
                    });
                };

                img.onerror = function(event) {
                    broadcastService.send("layoutImageLoadError", {
                        event: event
                    });
                };

                img.src = arg.src || event.target.result;
            },
            striking: function striking(p) {
                var timer, domId = p.getAttrId(), dom = document.getElementById(domId);
                if (dom) {
                    var className = dom.className;
                    className = className.replace(/\s*twinkling\s*/g, "");
                    dom.className = className;
                    className += " twinkling";
                    dom.className = className;

                    timer = setTimeout(function(){
                        var className = dom.className;
                        className = className.replace(/\s*twinkling\s*/g, "");
                        dom.className = className;
                    }, 2500);
                }

                if (p.pins && p.pins.length) p.pins.forEach(function(pin){
                    striking(pin);
                });
            },
            broadcastLayout: function(deviceController, realDevice) {
                broadcastService.send(events.layoutAlready, {
                    deviceController: deviceController,
                    realDevice: realDevice
                });
            },
            onLayout: function(scope, fn) {
                scope.$on(events.layoutAlready, fn);
            },
            broadcastTemplate: function(template) {
                broadcastService.send(events.templateAlready, template);
            },
            onTemplate: function(scope, fn) {
                scope.$on(events.templateAlready, fn);
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .factory('fileUploaderFactory', fileUploaderFactory);

    /** @ngInject */
    function fileUploaderFactory(FileUploader, httpRequestInterceptor) {
        return {
            create: function(config) {
				config.headers || (config.headers = {});
                config = httpRequestInterceptor.request(config);
                return new FileUploader(config);
            },
            maxFileSize: 5 * 1024 * 1024,
            maxFileNameLength: 50
		}
    }

})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .service('devicesService', devicesService);

    /** @ngInject */
    function devicesService(ApiBaseUrl, $http) {
        this.searchDevices = function(keyword) {
            return $http.get(ApiBaseUrl + 'devices?key=' + keyword);
        };
        this.saveBoardLayout = function(layout) {
            return $http.post(ApiBaseUrl + 'devicepin', layout);
        };
        this.pageDevices = function (pageIndex, limit) {
            return $http.get(ApiBaseUrl + 'devices?pageIndex=' + pageIndex + '&limit=' + limit);
        };
        this.getDeviceByModel = function(model) {
            return $http.get(ApiBaseUrl + 'devices/' + model);
        };
        this.getDeviceUploadedByModel = function(model) {
            return $http.get(ApiBaseUrl + 'devices/' + model + '/doc/uploaded');
        };
        this.createDevice = function(device) {
            return $http.post(ApiBaseUrl + 'devices', device);
        };
        this.createDeviceDetail = function(device) {
            return $http.post(ApiBaseUrl + 'devices/' + device.model + '/detail', device);
        };
        this.updateDevice = function(device) {
            return $http.put(ApiBaseUrl + 'devices/' + device.model, device);
        };
        this.getLayoutByModel = function(model) {
            return $http.get(ApiBaseUrl + 'devices/' + model + '/layout');
        };
        this.getDevicesByUserName = function(username) {
            return $http.get(ApiBaseUrl + 'users/' + username + '/devices');
        };
        this.bindToDevice = function(model, bindings) {
            return $http.post(ApiBaseUrl + 'devices/' + model +
                '/binding', {bindings: bindings});
        };
        this.getDeviceTemplate = function() {
            return $http.get(ApiBaseUrl + 'devices/template');
        };
        this.getRecentlyUpdatedDevices = function(limit) {
            return $http.get(ApiBaseUrl + 'statistics/device/latestCreated?limit=' + limit);
        }
        this.getDeviceTotalAmount = function() {
            return $http.get(ApiBaseUrl + 'statistics/device/totalAmount')
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('grootRpm')
        .controller('DeviceListController', DeviceListController);

    /** @ngInject */
    function DeviceListController(devicesService) {
        var vm = this;

        vm.pageRecords = {
            pageIndex: 1
        };

        vm.limit = 10;

        vm.gotoPage = function () {
            devicesService.pageDevices(vm.pageRecords.pageIndex, vm.limit).then(function(raps) {
                vm.pageRecords = raps.data;
            }, function(error) {
                error.pop();
            });
        };
    }
})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .factory('errorHandler', errorHandler);

    /** @ngInject */
    function errorHandler($injector, errors) {


        return {
            handle: function(response) {

                var error = {
                    originalResponse: angular.copy(response),
                    statusCode: response.status,
                    // code: undefined,
                    message: '',
                    pop: pop,
                    isNotFound: isNotFound
                };

                var data = response.data;

                // auth check
                if (response.status === 401 && !data.errorMessage) {
                    setTimeout(
                        function (params) {
                            var loc = window.location;
                            var url = loc.protocol + '//' + loc.host
                                + '/sso/loginUrl';
                            window.location = url;
                        }, 1000
                    );

                    error.message = errors['401'].default;
                    return error;
                }

                if (errors[response.status]) {
                    if (data && data.errorMessage && errors[response.status]
                        [
                            data.errorMessage.code
                        ]) {
                        error.message = errors[response.status]
                            [data.errorMessage.code];

                    } else {
                        error.message = errors[response.status].default;
                    }

                } else {
                    error.message = errors.others.default;
                }

                function isNotFound() {
                    return error.statusCode === 404;
                }

                function pop() {
                    $injector.get('toastr').error(error.message);
                }

                return error;

            }
        };

    }
})();
(function() {
    'use strict';

    angular.module('grootRpm')
        .factory('broadcastService', broadcastService);

    /** @ngInject */
    function broadcastService($rootScope) {
        return {
            send: function(msg, data) {
                $rootScope.$broadcast(msg, data);
            }
        }
    }
})();
(function() {

	'use strict';

	angular
		.module('grootRpm')
		.value('cgBusyDefaults', {
			backdrop: true,
			message: '',
			// minDuration: 500000,
			templateUrl: 'app/custom-templates/busy-template.html'
				// wrapperClass: 'my-class my-class2'
		});

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .config(theme);

    /** @ngInject */
    function theme($mdThemingProvider) {
        $mdThemingProvider.definePalette('grootPrimary', {
            '50': '#BAF9FF',
            '100': '#6EF2FF',
            '200': '#36EDFF',
            '300': '#00D8ED',
            '400': '#00BCCF',
            '500': '#00A0B0',
            '600': '#008491',
            '700': '#006873',
            '800': '#004D54',
            '900': '#003136',
            'A100': '#BAF9FF',
            'A200': '#6EF2FF',
            'A400': '#00BCCF',
            'A700': '#006873',
            'contrastDefaultColor': 'light', // whether, by default, text (contrast)
            // on this palette should be dark or light
            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'
            ],
            'contrastLightColors': undefined // could also specify this if default was 'dark'
        });



        $mdThemingProvider.definePalette('rasberry', {
            '50': '#ffffff',
            '100': '#f9f0f3',
            '200': '#e8c9d2',
            '300': '#d297a8',
            '400': '#c98196',
            '500': '#c06c84',
            '600': '#b75772',
            '700': '#a74863',
            '800': '#923e56',
            '900': '#7c354a',
            'A100': '#ffffff',
            'A200': '#f9f0f3',
            'A400': '#c98196',
            'A700': '#a74863',
            'contrastDefaultColor': 'light', // whether, by default, text (contrast)
            // on this palette should be dark or light
            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'
            ],
            'contrastLightColors': undefined // could also specify this if default was 'dark'

        });

        $mdThemingProvider.definePalette('grootAccent', {
            '50': '#E3D3CD',
            '100': '#C7A99C',
            '200': '#B38A78',
            '300': '#916552',
            '400': '#7E5847',
            '500': '#6A4A3C',
            '600': '#563C31',
            '700': '#432F26',
            '800': '#2F211B',
            '900': '#1C1310',
            'A100': '#E3D3CD',
            'A200': '#C7A99C',
            'A400': '#7E5847',
            'A700': '#432F26',
            'contrastDefaultColor': 'light', // whether, by default, text (contrast)
            // on this palette should be dark or light
            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'
            ],
            'contrastLightColors': undefined // could also specify this if default was 'dark'

        });
        $mdThemingProvider.definePalette('grootWarn', {
            '50': '#ffffff',
            '100': '#fdf0ec',
            '200': '#f8c7b9',
            '300': '#f19478',
            '400': '#ee7e5d',
            '500': '#eb6841',
            '600': '#e85225',
            '700': '#d84317',
            '800': '#bc3a14',
            '900': '#a13211',
            'A100': '#ffffff',
            'A200': '#fdf0ec',
            'A400': '#ee7e5d',
            'A700': '#d84317',
            'contrastDefaultColor': 'light', // whether, by default, text (contrast)
            // on this palette should be dark or light
            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'
            ],
            'contrastLightColors': undefined // could also specify this if default was 'dark'

        });
        $mdThemingProvider.theme('default')
            .primaryPalette('grootPrimary')
            .accentPalette('grootAccent')
            .warnPalette('grootWarn');
    }

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .run(runBlock);


    /** @ngInject */
    function runBlock($localStorage, $translate, momentLangService) {
        if ($localStorage.lang) {
            $translate.use($localStorage.lang);
            momentLangService.setLang();
        }
    }

})();
(function() {
	'use strict';

	angular
		.module('grootRpm')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider,
		$locationProvider, $urlMatcherFactoryProvider) {

		$stateProvider
			.state('main', {
				url: '/',
				templateUrl: 'app/main/main.html',
				controller: 'MainController',
				controllerAs: 'main'
			})
			.state('login', {
				url: '/login',
				controller: 'AuthenticationController',
				controllerAs: 'auth'
			})
			.state('signup', {
				url: '/signup',
				controller: 'AuthenticationController',
				controllerAs: 'auth',
				templateUrl: 'app/user/signup.html'
			})
			.state('404', {
				url: '/404',
				templateUrl: 'app/404.html'
			})
			.state('search', {
				url: '/search?keyword',
				controller: 'SearchController',
				controllerAs: 'search',
				templateUrl: 'app/search/search.html'
			})
			.state('devices', {
				template: "<ui-view></ui-view>",
				abstract: true
			})
			.state('devices.list', {
				url: '/devices',
				controller: 'DeviceListController',
				controllerAs: 'deviceList',
				templateUrl: 'app/devices/device-list.html'
			})
			.state('devices.create', {
				url: '/devices/new',
				controller: 'DeviceCreateController',
				controllerAs: 'device',
				templateUrl: 'app/devices/create/device-create.html'
			})
			.state('devices.show', {
				url: '/devices/{model:[a-zA-Z0-9]+(?:-[A-Za-z0-9]+)*}',
				controller: 'DeviceShowController',
				controllerAs: 'device',
				templateUrl: 'app/devices/show/device-show.html'
			})
			.state('devices.update', {
				url: '/devices/{model:[a-zA-Z0-9]+(?:-[A-Za-z0-9]+)*}/edit',
				controller: 'DeviceUpdateController',
				controllerAs: 'device',
				templateUrl: 'app/devices/create/device-create.html'
			})
			.state('raps', {
				template: "<ui-view></ui-view>",
				abstract: true
			})
			.state('raps.show', {
				url: '/raps/{name}',
				controller: 'RapShowController',
				controllerAs: 'rap',
				templateUrl: 'app/raps/rap-show.html'
			})
			.state('raps.list', {
				url: '/raps',
				controller: 'RapListController',
				controllerAs: 'rapList',
				templateUrl: 'app/raps/rap-list.html'
			})
			.state('user-home', {
				url: '/{username:[a-zA-Z0-9]+(?:-[A-Za-z0-9]+)*}',
				controller: 'UserHomeController',
				controllerAs: 'userHome',
				templateUrl: 'app/user/user-home.html'
			});

		$urlRouterProvider.otherwise('404');
		$urlMatcherFactoryProvider.strictMode(false);
		$locationProvider.html5Mode(true);
	}

})();
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .factory('httpRequestInterceptor', httpRequestInterceptor);

    /** @ngInject */
    function httpRequestInterceptor($q, $localStorage,
        errorHandler) {

        return {
            request: function(config) {
                config.headers['Authorization'] = 'Bearer ' +
                    $localStorage.token;
                return config;
            },
            response: function(response) {
                return response || $q.when(response);
            },
            responseError: function(response) {
                return $q.reject(errorHandler.handle(response));
            }
        }
    }
})();
/* global malarkey:false, moment:false */
(function() {
    'use strict';

    angular
        .module('grootRpm')
        .constant('malarkey', malarkey)
        .constant('moment', moment)
        .constant('errors', {
            '400': {
                'default': 'ERROR.PARAM_ERROR',
                '01': 'ERROR.RAP_PUBLISH_WITH_INCORRECT_FORMAT',
                '02': 'ERROR.USER_NAME_FORMAT_IS_INCORRECT',
                '04': 'ERROR.USER_ID_FORMAT_IS_INCORRECT',
                '05': 'ERROR.DEVICE_MODEL_NAME_FORMAT_INVALID',
                '30': 'ERROR.PARAM_ERROR',
                '99': 'ERROR.INVITED_USER_ONLY'
            },
            '401': {
                'default': 'ERROR.YOU_NEED_TO_LOGIN_FIRST',
                '01': 'ERROR.DEVICE_UPDATE_IS_NOT_AUTHORIZED',
                '02': 'ERROR.RAP_PUBLISH_IS_NOT_AUTHORIZED',
                '30': 'ERROR.USER_NAME_OR_PASSWORD_IS_WRONG'
            },
            '404': {
                'default': 'ERROR.NOT_FOUND',
                '01': 'ERROR.DEVICE_NOT_FOUND',
                '02': 'ERROR.RAP_FILE_NOT_FOUND',
                '03': 'ERROR.DEVICE_DOC_NOT_FOUND',
                '04': 'ERROR.DEVICE_IMAGE_NOT_FOUND',
                '05': 'ERROR.SYSTEM_CODE_NOT_FOUND',
                '06': 'ERROR.RAP_READ_ME_NOT_FOUND',
                '07': 'ERROR.DEVICE_IMAGE_META_DATA_NOT_FOUND',
                '30': 'ERROR.USER_NOT_FOUND'
            },
            '405': {
                'default': 'ERROR.METHOD_NOT_ALLOWED'
            },
            '409': {
                'default': 'ERROR.CONFLICT_DETECTED',
                '01': 'ERROR.DEVICE_DUPLICATED',
                '02': 'ERROR.RAP_DUPLICATED',
                '03': 'ERROR.RAP_NAME_IS_RETAINED',
                '30': 'ERROR.USER_ALREADY_EXIST'
            },
            '422': {
                'default': 'ERROR.PARAM_IS_MISSING'
            },
            '-1': {
                'default': 'ERROR.NETWORK_NOT_AVAILABLE'
            },
            '500': {
                'default': 'ERROR.SERVER_INTERNAL_ERROR'
            },
            'others': {
                'default': 'ERROR.SOMETHING_WENT_WRONG'
            }
        });

})();
(function () {
    'use strict';

    angular
        .module('grootRpm')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig, $httpProvider) {
        // Enable log
        $logProvider.debugEnabled(false);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 2000;
        toastrConfig.positionClass = 'toast-top-center';
        toastrConfig.preventDuplicates = false;
        toastrConfig.preventOpenDuplicates = true;
        toastrConfig.progressBar = false;
        toastrConfig.templates = {
            toast: 'app/custom-templates/toastr-template.html'
        };
        toastrConfig.iconClasses = {
            error: 'toast-error',
            info: 'toast-info',
            success: 'toast-success',
            warning: 'toast-warning'
        };

        $httpProvider.interceptors.push('httpRequestInterceptor');
    }

    angular
            .module('grootRpm')
            .config(['markedProvider', function (markedProvider) {
                markedProvider.setOptions({
                    gfm: true,
                    tables: true,
                    highlight: function (code, lang) {
                        if (lang) {
                            try {
                                return hljs.highlight(lang, code, true).value;
                            } catch (e) {
                                return hljs.highlightAuto(code).value;
                            }
                        } else {
                            return hljs.highlightAuto(code).value;
                        }
                    }
                });
                markedProvider.setRenderer({
                    code: function(code, lang, escaped) {
                        if (this.options.highlight) {
                            var out = this.options.highlight(code, lang);
                            if (out != null /*&& out !== code*/) {
                            escaped = true;
                            code = out;
                            }
                        }

                        if (!lang) {
                            return '<pre class="marked-code"><code>'
                            + (escaped ? code : escape(code, true))
                            + '\n</code></pre>';
                        }

                        return '<pre class="marked-code"><code class="'
                            + this.options.langPrefix
                            + escape(lang, true)
                            + '">'
                            + (escaped ? code : escape(code, true))
                            + '\n</code></pre>\n';
                    }
                });
            }]);
})();
angular.module("grootRpm").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.html","<div layout=\"row\" layout-align=\"center center\" class=\"not-found\"><img src=\"assets/images/404.svg\"></div>");
$templateCache.put("app/custom-templates/busy-template.html","<div class=\"busy-popup\"><div class=\"busy-message\" translate=\"\">{{$message}}</div></div>");
$templateCache.put("app/custom-templates/toastr-template.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\"><div class=\"{{messageClass}}\" aria-label=\"{{message}}\" translate=\"\">{{message}}</div></div>");
$templateCache.put("app/devices/device-list.html","<div><div layout-align=\"center center\" flex=\"100\" class=\"device-list-header\"><p><span translate=\"\">DEVICE.ALL_DEVICES</span><i class=\"fa fa-cube\"></i></p></div><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-card flex=\"100\" flex-gt-sm=\"60\"><md-list><md-list-item class=\"md-3-line list-with-padding\" ng-repeat=\"item in deviceList.pageRecords.records\"><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><h3 class=\"list-item-name\" ui-sref=\"devices.show({model: item.model})\"><i class=\"fa fa-calculator device-icon\"></i>{{ item.name }}</h3><p class=\"list-item-description\"><span ng-if=\"item.description\">{{item.description}}</span> <span ng-if=\"!item.description\" translate=\"\">NO_DESCRIPTION</span></p><p layout-align=\"center center\"><i class=\"material-icons\">developer_board</i>{{item.model}}</p><p layout-align=\"center center\"><i class=\"material-icons\">label</i> <span ng-repeat=\"keyword in item.keyWords\"><span>{{keyword}}{{$last?\'\':\', \'}}</span></span> <span ng-if=\"item.keyWords.length == 0\" translate=\"\">NO_KEYWORDS</span></p></div></md-list-item></md-list></md-card></div><wan-material-paging wmp-total=\"deviceList.pageRecords.pageCount\" goto-page=\"deviceList.gotoPage()\" position=\"center center\" current-page=\"deviceList.pageRecords.pageIndex\" step=\"deviceList.limit\"></wan-material-paging></div>");
$templateCache.put("app/main/main.html","<div layout-align=\"center center\" layout-padding=\"\" class=\"banner\"><p class=\"text-center banner-content\">Rap is the package manager for<acme-malarkey extra-values=\"[\'Ruff\']\"></acme-malarkey></p></div><div cg-busy=\"main.promise\" class=\"busy-mask\" layout-align=\"center\" layout=\"column\"><div layout-align=\"center center\" layout=\"column\" layout-gt-sm=\"row\" layout-sm=\"column\" class=\"banner-icons\"><div flex=\"20\" flex-sm=\"100\" flex-offset=\"15\" flex-offset-sm=\"0\" flex-offset-xs=\"0\" flex-offset-md=\"0\" layout=\"row\" layout-align=\"center center\" flex-xs=\"100\" class=\"total-raps\" ui-sref=\"raps.list\"><div flex=\"20\" flex-sm=\"50\" flex-xs=\"50\" flex-md=\"35\"><i class=\"fa fa-cube homepage-icon\"></i></div><div flex=\"80\" flex-sm=\"50\" flex-xs=\"50\" flex-md=\"65\"><p class=\"icon-stats\">{{main.rapTotalAmount}}</p><p class=\"icon-desc\" translate=\"\">MAIN.TOTAL_RAPS</p></div></div><div flex=\"20\" layout=\"row\" layout-align=\"center center\" flex-sm=\"100\" flex-xs=\"100\" class=\"total-devices\" ui-sref=\"devices.list\"><div flex=\"20\" flex-sm=\"50\" flex-md=\"35\" flex-xs=\"50\"><i class=\"fa fa-calculator homepage-icon\"></i></div><div flex=\"80\" flex-sm=\"50\" flex-md=\"65\" flex-xs=\"50\"><p class=\"icon-stats\">{{main.deviceTotalAmount}}</p><p class=\"icon-desc\" translate=\"\">MAIN.TOTAL_DEVICES</p></div></div><div flex=\"20\" layout=\"row\" layout-align=\"center center\" flex-sm=\"100\" flex-xs=\"100\"><div flex=\"20\" flex-sm=\"50\" flex-md=\"35\" flex-xs=\"50\"><i class=\"fa fa-cloud-download homepage-icon\"></i></div><div flex=\"80\" flex-sm=\"50\" flex-md=\"65\" flex-xs=\"50\"><p class=\"icon-stats\">{{main.rapTotalDownloadTimes}}</p><p class=\"icon-desc\" translate=\"\">MAIN.TOTAL_DOWNLOADS</p></div></div></div><div layout-align=\"center center\" class=\"top-rap-header\"><p><span translate=\"\">MAIN.TOP_DOWNLOADS_TITLE</span><i class=\"fa fa-cube\"></i></p></div><div class=\"techs\" layout-align=\"center center\" layout=\"column\" layout-gt-sm=\"row\"><md-card flex-sm=\"100\" flex-xs=\"100\" flex=\"30\" ng-repeat=\"rap in main.topDownloadRaps | limitTo: 12 | orderBy:\'download\'\"><md-card-content layout=\"row\" layout-align=\"center start\" ui-sref=\"raps.show({name: rap.rapName})\" class=\"homepage-card\"><div flex=\"30\"><random-avatar seed=\"{{rap.rapName}}\"></random-avatar></div><div flex=\"\" class=\"homepage-rap-info\"><p class=\"homepage-rap-name\">{{ rap.rapName }}</p><p class=\"homepage-rap-description\">{{ rap.description | characters:40: false}}</p></div></md-card-content></md-card></div><div layout-align=\"center center\" class=\"top-rap-header\"><p><span translate=\"\">MAIN.RECENTLY_UPDATED_RAPS</span><i class=\"fa fa-cube\"></i></p></div><div class=\"techs\" layout-align=\"center center\" layout=\"column\" layout-gt-sm=\"row\"><md-card flex-sm=\"100\" flex-xs=\"100\" flex=\"30\" ng-repeat=\"rap in main.recentlyUpdatedRaps | limitTo: 12\"><md-card-content layout=\"row\" layout-align=\"center start\" ui-sref=\"raps.show({name: rap.name})\" class=\"homepage-card\"><div flex=\"30\"><random-avatar seed=\"{{rap.name}}\"></random-avatar></div><div flex=\"\" class=\"homepage-rap-info\"><p class=\"homepage-rap-name\">{{ rap.name }}</p><p class=\"homepage-rap-description\">{{ rap.description | characters:40: false}}</p></div></md-card-content></md-card></div><div layout-align=\"center center\" class=\"top-rap-header\"><p><span translate=\"\">MAIN.RECENTLY_CREATED_DEVICES</span><i class=\"fa fa-calculator\"></i></p></div><div class=\"techs\" layout-align=\"center center\" layout=\"column\" layout-gt-sm=\"row\"><md-card flex-sm=\"100\" flex-xs=\"100\" flex=\"30\" ng-repeat=\"device in main.recentlyUpdatedDevices | limitTo: 12\"><md-card-content layout=\"row\" layout-align=\"center start\" ui-sref=\"devices.show({model: device.model})\" class=\"homepage-card\"><div flex=\"30\"><random-avatar seed=\"{{device.name}}\"></random-avatar></div><div flex=\"\" class=\"homepage-rap-info\"><p class=\"homepage-rap-name\">{{ device.name }}</p><p class=\"homepage-rap-description\">{{ device.model | characters:40: false}}</p></div></md-card-content></md-card></div></div>");
$templateCache.put("app/raps/rap-list.html","<div><div layout-align=\"center center\" flex=\"100\" class=\"rap-list-header\"><p><span translate=\"\">RAP.ALL_RAPS</span><i class=\"fa fa-cube\"></i></p></div><div flex=\"100\" layout=\"row\" layout-align=\"center center\"><md-card flex=\"100\" flex-gt-sm=\"60\"><md-list><md-list-item class=\"md-2-line list-with-padding\" ng-repeat=\"item in rapList.pageRecords.records\"><div class=\"md-list-item-text\" layout=\"column\" flex=\"\"><div class=\"list-item-name rap-name\" flex=\"100\"><span ui-sref=\"raps.show({name: item.name})\">{{ item.name }}</span> &nbsp;&nbsp; <span class=\"clickable blue\" ui-sref=\"user-home({username:item.user.name})\">{{item.user.name}}</span></div><p class=\"list-item-description rap-description\" translate=\"\" translate-value-version=\"{{item.version}}\">RAP_VERSION</p></div></md-list-item></md-list></md-card></div><wan-material-paging wmp-total=\"rapList.pageRecords.pageCount\" goto-page=\"rapList.gotoPage()\" position=\"center center\" current-page=\"rapList.pageRecords.pageIndex\" step=\"rapList.limit\"></wan-material-paging></div>");
$templateCache.put("app/raps/rap-show.html","<div cg-busy=\"rap.promise\" class=\"busy-mask\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" id=\"rap-detail\"><div flex=\"\" flex-gt-xs=\"50\" flex-offset-gt-xs=\"10\" layout=\"column\"><div flex=\"\"><span class=\"rap-name\"><i class=\"fa fa-cube rap-icon\"></i>{{rap.rap.name}}</span> <span class=\"rap-version\">v{{rap.rap.version}}</span></div><div flex=\"\" class=\"readme\"><div marked=\"rap.rap.readme\" ng-if=\"rap.rap.readme\"></div><div ng-if=\"!rap.rap.readme\" translate=\"\">RAP.RAP_README_NOT_FOUND</div></div></div><div flex=\"\" layout=\"column\" flex-offset-gt-xs=\"5\"><div layout=\"column\" class=\"rap-basic\"><div class=\"rap-install-command\"><md-icon aria-label=\"install\" class=\"md-accent\">file_download</md-icon><span>rap install {{rap.rap.name}}</span></div><div class=\"rap-release-info\"><div><span class=\"clickable blue\" ui-sref=\"user-home({username:rap.rap.user.name})\">{{rap.rap.user.name}}</span> <span translate=\"\" translate-value-time=\"{{rap.createTime}}\">RAP.RELEASED_ON</span></div><div ng-if=\"rap.releasedCount == 1\"><p translate=\"\" translate-value-version=\"{{rap.latestRap.version}}\">ONLY_ONE_RELEASE</p></div><div ng-if=\"rap.releasedCount > 1\"><span ng-class=\"rap.isLatestVersion? \'\' : \'clickable blue\'\" ui-sref=\"raps.show({name:rap.latestRap.name})\">{{rap.latestRap.version}}</span> <span translate-value-count=\"{{rap.releasedCount}}\" translate=\"\">NEWEST_RELEASE</span></div><div ng-if=\"rap.latestRap.browserUrlOfRepository\"><a href=\"{{rap.latestRap.browserUrlOfRepository}}\" class=\"clickable blue\" target=\"_blank\">{{rap.latestRap.browserUrlOfRepository}}</a></div><div ng-if=\"!rap.latestRap.browserUrlOfRepository && rap.latestRap.repository\">{{rap.latestRap.repository}}</div><div ng-if=\"rap.latestRap.license\">{{rap.latestRap.license}}</div></div></div><div layout=\"column\" ng-class=\"rap.supportedDevices.devices != 0 ? \'rap-stats\' : \'rap-deps\'\"><div class=\"rap-section-header\" translate=\"\">STATISTICS</div><div><p translate=\"\" translate-value-count=\"{{rap.statistics.currentDayDownloadCounts}}\">DOWNLOADS_OF_TODAY</p><p translate=\"\" translate-value-count=\"{{rap.statistics.lastWeekDownloadCounts}}\">DOWNLOADS_OF_LAST_WEEK</p><p translate=\"\" translate-value-count=\"{{rap.statistics.lastMonthDownloadCounts}}\">DOWNLOADS_OF_LAST_MONTH</p></div></div><div layout=\"column\" class=\"rap-deps\" ng-if=\"rap.supportedDevices.devices != 0\"><div class=\"rap-section-header\" translate=\"\">SUPPORT_DEVICE</div><md-list><md-list-item ng-repeat=\"item in rap.supportedDevices.devices\"><a class=\"blue\" ng-click=\"rap.goToDetailPage(item.model)\">{{item.name}}</a></md-list-item></md-list></div></div></div></div>");
$templateCache.put("app/user/login.html","<div cg-busy=\"auth.promise\" class=\"busy-mask\"><div class=\"container\"><div class=\"card\"></div><div class=\"card\"><h1 class=\"title\" translate=\"\">LOG_IN</h1><form name=\"loginForm\" novalidate=\"\" layout=\"column\" class=\"auth-form\" ng-submit=\"auth.login()\"><md-input-container><label translate=\"\">USER.EMAIL_OR_USERNAME</label> <input required=\"\" name=\"username\" ng-model=\"auth.user.name\"><div ng-messages=\"loginForm.username.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-input-container><label translate=\"\">PASSWORD</label> <input required=\"\" type=\"password\" name=\"password\" ng-model=\"auth.user.password\"><div ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-button type=\"submit\" ng-disabled=\"loginForm.$invalid\" class=\"md-primary auth-button\"><span translate=\"\">NEXT</span></md-button><div class=\"footer\"><a ui-sref=\"signup\" translate=\"\">USER.DO_NOT_HAVE_AN_ACCOUNT</a></div></form></div></div></div>");
$templateCache.put("app/user/signup.html","<div cg-busy=\"auth.promise\" class=\"busy-mask\"><div class=\"container\" ng-class=\"{active: active}\"><div class=\"card\"></div><div class=\"card\"><h1 class=\"title\" translate=\"\">SIGN_UP</h1><form name=\"signupForm\" novalidate=\"\" layout=\"column\" class=\"auth-form\" ng-submit=\"auth.signup()\"><md-input-container><label translate=\"\">USER.EMAIL</label><input ng-required=\"true\" name=\"email\" ng-model=\"auth.user.email\" email-available=\"\" ng-pattern=\"/^[a-z\\d]+(?:[_.-][a-z\\d]+)*@[a-z\\d]+(?:[.-][a-z\\d]+)*\\.[a-z]{2,63}$/i\" ng-model-options=\"{ debounce: 500 }\"><div ng-messages=\"signupForm.email.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div><div ng-message=\"pattern\"><span translate=\"\">USER.EMAIL_INVALID</span></div><div ng-message=\"usernameOccupied\"><span translate=\"\">USER.USERNAME_ALREADY_EXIST</span></div></div></md-input-container><md-input-container><label translate=\"\">USERNAME</label> <input ng-required=\"true\" name=\"username\" ng-model=\"auth.user.name\" username-available=\"\" ng-model-options=\"{ debounce: 500 }\" ng-pattern=\"/^[a-z\\d]+(-[a-z\\d]+)*$/i\"><div ng-messages=\"signupForm.username.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div><div ng-message=\"pattern\"><span translate=\"\">USER.USERNAME_PATTERN_IS_REQUIRED</span></div><div ng-message=\"usernameOccupied\"><span translate=\"\">USER.USERNAME_ALREADY_EXIST</span></div></div></md-input-container><md-input-container><label translate=\"\">PASSWORD</label> <input ng-required=\"true\" type=\"password\" name=\"password1\" ng-model=\"auth.user.password\"><div ng-messages=\"signupForm.password1.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-input-container><label translate=\"\">REPEAT_PASSWORD</label> <input ng-required=\"true\" type=\"password\" name=\"password2\" password-match-check=\"auth.user.password\" ng-model=\"auth.confirmedPassword\"><div ng-messages=\"signupForm.password2.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div><div ng-message=\"passwordMatch\"><span translate=\"\">PASSWORD_NOT_MATCH</span></div></div></md-input-container><md-button type=\"submit\" ng-disabled=\"signupForm.$invalid || auth.waiting\" class=\"md-primary auth-button\"><span translate=\"\">GO</span></md-button><div class=\"footer\"><a ui-sref=\"login\" translate=\"\">USER.ALREADY_HAVE_AN_ACCOUNT</a></div></form></div></div></div>");
$templateCache.put("app/user/user-home-devices.html","<md-content class=\"md-padding\" id=\"user-home-device\"><md-list><div class=\"md-no-sticky md-subheader\" layout=\"row\" layout-align=\"space-between center\"><div class=\"md-subheader-inner\"><span class=\"md-subheader-content\"><div translate=\"\" translate-value-count=\"{{userHome.devices.length?userHome.devices.length:0}}\">MY_DEVICES_LIST_TITLE</div></span></div><div ng-if=\"userHome.isSelf\"><md-button ui-sref=\"devices.create\" class=\"md-raised md-primary\"><div translate=\"\">ADD_DEVICE</div></md-button></div></div><md-list-item class=\"md-3-line list-with-padding\" ng-repeat=\"item in userHome.devices\"><div class=\"md-list-item-text\" layout=\"column\"><h3 class=\"list-item-name\" ui-sref=\"devices.show({model: item.model})\"><i class=\"fa fa-calculator device-icon\"></i>{{ item.name }}</h3><p class=\"list-item-description\" ng-if=\"item.description\">{{item.description}}</p><p class=\"list-item-description\" ng-if=\"!item.description\" translate=\"\">NO_DESCRIPTION</p><p layout-align=\"center center\"><i class=\"material-icons\">developer_board</i> <span>{{item.model}}</span></p><p layout-align=\"center center\"><i class=\"material-icons\">label</i> <span ng-repeat=\"keyword in item.keyWords\">{{keyword}}{{$last?\'\':\', \'}}</span> <span ng-show=\"item.keyWords.length===0\" translate=\"\">NO_KEYWORDS</span></p></div></md-list-item></md-list></md-content>");
$templateCache.put("app/user/user-home-raps.html","<md-content class=\"md-padding\"><md-list><md-subheader class=\"md-no-sticky\"><div translate=\"\" translate-value-count=\"{{userHome.raps.length>0?userHome.raps.length:0}}\">MY_RAPS_LIST_TITLE</div></md-subheader><md-list-item class=\"md-3-line list-with-padding\" ng-repeat=\"item in userHome.raps\"><div class=\"md-list-item-text\" layout=\"column\"><h3 class=\"list-item-name\" ui-sref=\"raps.show({name: item.name})\"><i class=\"fa fa-cube rap-icon\"></i>{{ item.name }}</h3><p class=\"list-item-description rap-description\" translate=\"\" translate-value-version=\"{{item.version}}\">RAP_VERSION</p></div></md-list-item></md-list></md-content>");
$templateCache.put("app/user/user-home.html","<div cg-busy=\"userHome.promise\" class=\"busy-mask\"><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"center start\" layout-padding=\"\" class=\"margin-top\" layout-align-xs=\"center center\"><div flex=\"\" flex-gt-xs=\"25\" flex-gt-lg=\"15\" layout=\"column\" class=\"user-info\" layout-align-xs=\"center center\"><random-avatar seed=\"{{userHome.user.username}}\"></random-avatar><div class=\"username section\">{{userHome.userProfile.name}}</div><div class=\"info\"><div layout=\"row\" layout-align=\"start center\"><i class=\"fa fa-envelope-o\"></i> <span>{{userHome.userProfile.email}}</span></div></div></div><md-tabs flex=\"\" flex-gt-xs=\"50\" flex-gt-lg=\"40\" md-dynamic-height=\"\" md-border-bottom=\"\" class=\"devices-and-raps\"><md-tab><md-tab-label><i class=\"fa fa-cube\"></i> <span translate=\"\">{{userHome.isSelf?\'MY_RAPS\':\'RAP.RAP\'|translate}}</span></md-tab-label><md-tab-body><div ng-include=\"\'app/user/user-home-raps.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><i class=\"fa fa-calculator\"></i> <span>{{userHome.isSelf?\'MY_DEVICES\':\'DEVICE.DEVICE\'|translate}}</span></md-tab-label><md-tab-body><div ng-include=\"\'app/user/user-home-devices.html\'\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/search/search.html","<div cg-busy=\"search.promise\" class=\"busy-mask\"><p class=\"search-result-header\" translate=\"\" translate-value-count=\"{{search.devices.length + search.raps.length}}\">SEARCH_RESULT_TITLE</p><div layout=\"row\" flex-offset=\"10\" class=\"margin-top\" layout-sm=\"column\" flex-offset-sm=\"0\"><md-card flex=\"40\" flex-sm=\"100\" flex-offset-sm=\"0\"><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"\" translate-value-count=\"{{search.devices.length}}\">DEVICES_LIST_RESULT_TITLE</span></md-subheader><md-list-item class=\"md-3-line list-with-padding\" ng-repeat=\"item in search.devices\"><div class=\"md-list-item-text\" layout=\"column\"><h3 class=\"list-item-name\" ui-sref=\"devices.show({model: item.model})\"><i class=\"fa fa-calculator device-icon\"></i>{{ item.name }}</h3><p class=\"list-item-description\"><span ng-if=\"item.description\">{{item.description}}</span> <span ng-if=\"!item.description\" translate=\"\">NO_DESCRIPTION</span></p><p layout-align=\"center center\"><i class=\"material-icons\">developer_board</i>{{item.model}}</p><p layout-align=\"center center\"><i class=\"material-icons\">label</i> <span ng-repeat=\"keyword in item.keyWords\"><span>{{keyword}}{{$last?\'\':\', \'}}</span></span> <span ng-if=\"item.keyWords.length == 0\" translate=\"\">NO_KEYWORDS</span></p></div></md-list-item></md-list></md-card><md-card flex=\"40\" flex-offset=\"10\" flex-sm=\"100\" flex-offset-sm=\"0\"><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"\" translate-value-count=\"{{search.raps.length}}\">RAPS_LIST_RESULT_TITLE</span></md-subheader><md-list-item class=\"md-3-line list-with-padding\" ng-repeat=\"item in search.raps\"><div class=\"md-list-item-text\" layout=\"column\"><h3 class=\"list-item-name\" ui-sref=\"raps.show({name: item.name})\"><i class=\"fa fa-cube rap-icon\"></i>{{ item.name }}</h3><p class=\"list-item-description rap-description\" translate=\"\" translate-value-version=\"{{item.version}}\">RAP_VERSION</p></div></md-list-item></md-list></md-card></div></div>");
$templateCache.put("app/components/board/board.html","<div id=\"board\" class=\"board\" ui-on-drop=\"uploader.onDrop($event, $data)\" drop-channel=\"board\"><div ng-repeat=\"pin in uploader.pins track by $index\" ng-class=\"pin.getCssClass()\" ui-draggable=\"true\" drag-channel=\"board\" drag=\"pin\" ng-attr-id=\"{{ pin.getAttrId() }}\" ng-style=\"{top: pin.y + \'px\', left:pin.x + \'px\', \'background-color\': uploader.pinService.generateColor(pin.pinCategoryCode)}\"><md-tooltip md-direction=\"right\">{{pin.pin}}</md-tooltip></div></div>");
$templateCache.put("app/components/board-show/board-show.html","<div id=\"board\" class=\"board\"><div ng-repeat=\"pin in pinsLayout.pins\" ng-class=\"pin.getCssClass()\" ng-mouseover=\"pin-hover\" ng-attr-id=\"{{ pin.getAttrId() }}\" ng-style=\"{top: pin.y + \'px\', left:pin.x + \'px\', \'background-color\': pinsLayout.generateColor(pin.pinCategoryCode)}\"><md-tooltip md-direction=\"right\" md-autohide=\"false\">{{pin.pin}}</md-tooltip></div></div>");
$templateCache.put("app/components/header/header.html","<md-toolbar class=\"search-bar\" layout=\"row\" hide-xs=\"\" hide-sm=\"\" layout-align=\"start center\"><div flex=\"10\" flex-offset=\"5\"><h3 ui-sref=\"main\" class=\"clickable search-label\" translate=\"\">RAP</h3></div><div flex=\"65\" layout=\"row\" layout-align=\"space-between\" flex-md=\"55\"><search class=\"md-toolbar-tools\"></search></div><div flex=\"\"><user-bar class=\"md-toolbar-tools\"></user-bar></div></md-toolbar><md-toolbar class=\"search-bar\" layout=\"column\" layout-align=\"center\" hide-gt-sm=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"30\" flex-offset=\"5\"><h3 ui-sref=\"main\" class=\"clickable search-label\">Rap</h3></div><div><user-bar class=\"md-toolbar-tools\"></user-bar></div></div><div layout=\"row\" layout-align=\"space-between\" layout-padding=\"\"><search class=\"md-toolbar-tools\"></search></div></md-toolbar>");
$templateCache.put("app/components/i18n/translate.directive.html","<div layout=\"row\" layout-align=\"start center\" class=\"languages\"><span ng-click=\"changeLanguage(\'zh\')\" ng-class=\"{active: lang===\'zh\'}\">简体中文</span> <span ng-click=\"changeLanguage(\'en\')\" ng-class=\"{active: lang===\'en\'}\">English</span></div>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=\"row\" layout-align=\"start center\" class=\"nav-bar\"><div flex=\"\" layout-align=\"end center\" layout=\"row\" ng-if=\"navBar.show\"><md-button ui-sref=\"devices.create\"><span translate=\"\">NAV_BAR.ADD_DEVICE</span></md-button><md-button ui-sref=\"user-home({username: navBar.user.name})\"><span translate=\"\">NAV_BAR.HOME</span></md-button></div></md-toolbar>");
$templateCache.put("app/components/search/search.html","<div flex=\"90\"><form ng-submit=\"search.closeDropdownAndSearch()\"><md-autocomplete md-no-cache=\"true\" id=\"mainSearch\" md-selected-item=\"search.selectedItem\" md-min-length=\"1\" md-search-text=\"search.text\" md-items=\"item in search.querySearch(search.text)\" md-delay=\"500\" md-autoselect=\"false\" md-item-text=\"item.name\" md-autofocus=\"true\" md-selected-item-change=\"search.goToDetailPage(search.selectedItem)\" placeholder=\"{{\'SEARCH_RAPS_OR_DEVICES\'| translate}}\"><md-item-template><i ng-if=\"item.model\" class=\"fa fa-calculator device-icon\"></i> <i ng-if=\"!item.model\" class=\"fa fa-cube rap-icon\"></i> <span md-highlight-text=\"search.text\">{{item.name}}</span></md-item-template></md-autocomplete></form></div><div><md-button class=\"md-icon-button md-primary\" aria-label=\"search\" ng-click=\"search.search()\"><i class=\"material-icons search-button\">search</i></md-button></div>");
$templateCache.put("app/components/user-bar/user-bar.html","<div ng-if=\"!userBar.loggedIn\" class=\"auth\"><a href=\"/sso/loginUrl\" target=\"_self\"><span translate=\"\">LOG_IN</span></a></div><div ng-if=\"userBar.loggedIn\" layout=\"column\"><div class=\"username clickable\" ui-sref=\"user-home({username: userBar.username})\">{{userBar.username}}</div><div class=\"logout clickable font-brown\" ng-click=\"userBar.logout()\" translate=\"\">LOG_OUT</div></div>");
$templateCache.put("app/devices/create/device-create-binding.html","<div flex=\"\" class=\"form-card\"><md-autocomplete md-selected-item=\"binding.selectedItem\" md-search-text=\"binding.searchText\" md-selected-item-change=\"binding.selectedItemChange(item)\" md-items=\"item in binding.querySearch(binding.searchText)\" md-autoselect=\"true\" md-autofocus=\"true\" md-delay=\"500\" md-min-length=\"1\" md-no-cache=\"true\" md-item-text=\"item.name\" placeholder=\"{{\'DEVICE.INPUT_DRIVER_NAME_FOR_QUERY\'| translate}}\"><md-item-template><span md-highlight-text=\"binding.searchText\" md-highlight-flags=\"i\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"\">DEVICE.NOT_FOUND_DRIVER</span></md-not-found></md-autocomplete><md-list><md-list-item ng-repeat=\"item in binding.selectedRaps\"><p ng-click=\"binding.goToDetailPage(item.name)\" class=\"binding-list-item\">{{item.name}}</p><md-select placeholder=\"{{item.version}}\" ng-model=\"item.version\" md-on-open=\"binding.loadVersion(item.name)\" style=\"min-width: 200px;\"><md-option ng-value=\"version\" ng-repeat=\"version in binding.rapVersions[item.name].versions\">{{version}}</md-option></md-select><i class=\"fa fa-times\" ng-click=\"binding.removeSelectedRap(item)\"><span translate=\"\">DEVICE.UNBIND</span></i></md-list-item></md-list><div layout=\"row\" layout-align=\"end\" layout-sm=\"column\" layout-align-sm=\"center\"><md-button class=\"md-raised md-primary\" ng-click=\"binding.create()\" ng-if=\"!device.edit\"><span translate=\"\">CREATE</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"binding.skipToNext()\" ng-if=\"!device.edit\"><span translate=\"\">DEVICE.SKIP_TO_NEXT</span></md-button><md-button class=\"md-raised md-primary\" ng-click=\"binding.update()\" ng-if=\"device.edit\"><span translate=\"\">SAVE</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"binding.cancel()\" ng-if=\"device.edit\"><span translate=\"\">GIVEUP_EDITING</span></md-button></div></div>");
$templateCache.put("app/devices/create/device-create-board-layout-upload.html","<div layout=\"column\" id=\"layout-upload\"><div flex=\"\" layout=\"column\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"!uploader.imageUploaded && !uploader.imageUploader.isCalled()\" layout-padding=\"\"><div nv-file-drop=\"\" uploader=\"uploader.imageUploader\"><div nv-file-over=\"\" uploader=\"uploader.imageUploader\" over-class=\"file-over-class\" class=\"well my-drop-zone\" style=\"text-align:center;\" translate=\"\">DROP_BOARD_PHRASE</div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button class=\"file-upload md-raised md-primary\"><span translate=\"\">SELECT_IMAGE_FILE</span> <input type=\"file\" class=\"upload\" uploader=\"uploader.imageUploader\" nv-file-select=\"\"></md-button><md-button class=\"md-raised md-primary\" ng-click=\"uploader.skipToNext()\" md-no-ink=\"false\" md-ripple-size=\"auto\" ng-if=\"!uploader.deviceController.edit\"><span translate=\"\">DEVICE.SKIP_TO_NEXT</span></md-button></div></div><div flex=\"\" layout=\"column\" cg-busy=\"uploader.promise\" class=\"md-subhead\" ng-if=\"uploader.imageUploaded || uploader.imageUploader.isCalled()\" layout-padding=\"\" id=\"bus-instruction\"><div translate=\"\">DEVICE.LAYOUT_MANUAL_1</div><div layout=\"row\" layout-align=\"start center\"><div translate=\"\" class=\"bus-label\">DEVICE.INPUT_PINS</div><div ng-repeat=\"bus in uploader.dataBus.in\" class=\"bus-pin\" drag-channel=\"board\" ui-draggable=\"true\" drag=\"bus\" layout=\"row\" layout-align=\"center center\"><div class=\"pin pin-io-in pin-caption\" ng-style=\"{\'background-color\': uploader.pinService.generateColor(bus.code)}\"></div><div flex=\"\" class=\"bus-name\">{{bus.name}}</div></div></div><div layout=\"row\" layout-align=\"start center\"><div translate=\"\" class=\"bus-label\">DEVICE.OUTPUT_PINS</div><div ng-repeat=\"bus in uploader.dataBus.out\" class=\"bus-pin\" drag-channel=\"board\" ui-draggable=\"true\" drag=\"bus\" layout=\"row\" layout-align=\"center center\"><div class=\"pin pin-io-out pin-caption\" ng-style=\"{\'background-color\': uploader.pinService.generateColor(bus.code)}\"></div><div flex=\"\" class=\"bus-name\">{{bus.name}}</div></div></div><div layout=\"row\" id=\"image-and-pins\"><div flex=\"\" id=\"layout-image\"><div layout-align=\"center center\" layout=\"column\" ng-if=\"uploader.imageUploader.isCalled()\"><div board=\"uploader.layoutImage.lastItem\" class=\"boardCanvas\"></div><md-card class=\"uploading-progress\" layout=\"row\" ng-if=\"uploader.imageUploader.isShowProcess()\"><p translate=\"\" translate-value-percentage=\"{{uploader.imageUploader.getProcess()}}\">IMAGE_UPLOAD_PROGRESS</p></md-card></div><div id=\"imageCanvas\"><div flex=\"\" layout-align=\"center center\" layout=\"column\" ng-if=\"!uploader.imageUploader.isCalled()\"><div board=\"uploader.layoutImage.lastItem\" class=\"boardCanvas\"></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\"><md-button class=\"file-upload md-raised md-primary\"><span translate=\"\">SELECT_IMAGE_FILE</span> <input type=\"file\" class=\"upload\" uploader=\"uploader.imageUploader\" nv-file-select=\"\"></md-button><md-button class=\"md-raised md-accent\" ng-click=\"uploader.saveLayout()\" aria-label=\"save layout\" md-no-ink=\"false\" md-ripple-size=\"auto\" ng-disabled=\"!(uploader.imageUploaded)\"><span translate=\"\">SAVE_LAYOUT</span></md-button><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"!uploader.deviceController.edit\"><md-button class=\"md-raised md-primary\" ng-click=\"uploader.skipToNext()\" md-no-ink=\"false\" md-ripple-size=\"auto\"><span translate=\"\">DEVICE.SKIP_TO_NEXT</span></md-button></div></div></div><div flex=\"20\" layout=\"column\" id=\"layout-pins\" layout-padding=\"\"><div class=\"md-subhead\" translate=\"\">DEVICE.PINS_ALREADY</div><div ng-repeat=\"pin in uploader.groupPins\" layout-align=\"center center\"><div layout=\"row\" style=\"line-height: 1.2em; margin-top: 3px;\" layout-align=\"center center\"><div ng-class=\"pin.getCssClass() + \' pin-caption\'\" style=\"margin-right:3px;outline:medium;\" ng-style=\"{\'background-color\': uploader.pinService.generateColor(pin.pinCategoryCode)}\" ng-click=\"uploader.pinService.striking(pin)\"></div><input ng-model=\"pin.pin\" ng-change=\"pin.changeName()\" pinname-available=\"\" class=\"pin-name\" flex=\"80\" style=\"border-width:0px 0px 1px 0px;border-bottom-color:rgba(0, 0, 0, 0.117647);outline:medium;\"><div flex=\"10\" layout=\"row\" layout-align=\"end center\"><i class=\"fa fa-times clickable\" ng-click=\"uploader.pinService.removePinPoint(pin)\"></i></div></div><div layout=\"row\" ng-repeat=\"ipin in pin.pins\" class=\"child-pins\" style=\"line-height: 1.2em; margin-top: 3px;\"><div flex=\"\" class=\"clickable\" style=\"margin-right:3px;outline:medium;\" ng-click=\"uploader.pinService.striking(ipin)\">{{ipin._pin}}</div><div flex=\"10\" layout=\"row\" layout-align=\"end center\" ng-if=\"ipin.removable\"><i class=\"fa fa-times clickable\" ng-click=\"uploader.pinService.removePinPoint(ipin)\"></i></div></div></div></div></div></div></div>");
$templateCache.put("app/devices/create/device-create-info.html","<div cg-busy=\"device.promise\" class=\"busy-mask\"><md-content class=\"md-padding\"><form name=\"myForm\" layout=\"column\" novalidate=\"\" ng-cloak=\"\"><md-content layout=\"column\" layout-sm=\"column\" class=\"form-card\"><md-input-container><label translate=\"\">DEVICE_NAME</label> <input required=\"\" name=\"deviceName\" ng-model=\"device.device.name\"><div ng-messages=\"myForm.deviceName.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-input-container><label translate=\"\">DEVICE_MODEL</label> <input required=\"\" ng-disabled=\"device.edit\" name=\"deviceModel\" ng-model=\"device.device.model\" ng-pattern=\"/^[a-z\\d]+(-[a-z\\d]+)*$/i\"><div ng-messages=\"myForm.deviceModel.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div><div ng-message=\"pattern\"><span translate=\"\">DEVICE.MODEL_PATTERN_INVALID</span></div></div></md-input-container><md-input-container><label translate=\"\">DEVICE_DESCRIPTION</label> <textarea required=\"\" name=\"description\" maxlength=\"200\" ng-model=\"device.device.description\"></textarea><div ng-messages=\"myForm.description.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-chips ng-model=\"device.device.keyWords\" placeholder=\"{{\'DEVICE_KEYWORD\'| translate}}\" delete-button-label=\"Remove keyword\" delete-hint=\"Press delete to remove keyword\" secondary-placeholder=\"{{\'INPUT_KEYWORD_AND_PRESS_ENTER\'|translate}}\"></md-chips><div layout=\"row\" layout-align=\"end\" layout-sm=\"column\" layout-align-sm=\"center\" ng-if=\"!device.edit\"><md-button ng-click=\"device.createDevice()\" class=\"md-raised md-primary\" ng-disabled=\"myForm.$invalid\"><span translate=\"\">CREATE</span></md-button></div><div layout=\"row\" layout-align=\"end\" layout-sm=\"column\" layout-align-sm=\"center\" ng-if=\"device.edit\"><md-button ng-click=\"device.updateDeviceBasic()\" class=\"md-raised md-primary\" ng-disabled=\"myForm.$invalid\"><span translate=\"\">SAVE</span></md-button><md-button ng-click=\"device.cancelEditBasic()\" class=\"md-raised md-accent\"><span translate=\"\">GIVEUP_EDITING</span></md-button></div></md-content></form></md-content></div>");
$templateCache.put("app/devices/create/device-create-optional-info.html","<div cg-busy=\"deviceDetail.promise\" class=\"busy-mask\"><md-content class=\"md-padding\"><form name=\"myForm\" layout=\"column\" novalidate=\"\" ng-cloak=\"\"><md-content layout=\"column\" layout-sm=\"column\" class=\"form-card\"><p class=\"section-title\" translate=\"\">BASIC_INFO</p><div layout=\"row\" layout-align=\"space-between\" layout-sm=\"column\"><md-input-container><label translate=\"\">DEVICE_MANUFACTURE</label> <textarea name=\"manufacturer\" maxlength=\"100\" ng-model=\"deviceDetail.device.manufacturer\"></textarea></md-input-container><md-input-container><label translate=\"\">DEVICE_PRODUCTION_PHASE</label> <textarea maxlength=\"100\" ng-model=\"deviceDetail.device.productionPhase\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"space-between\" layout-sm=\"column\"><md-input-container flex=\"30\"><md-select required=\"\" multiple=\"\" name=\"dataBus\" ng-model=\"deviceDetail.device.dataBus\" placeholder=\"{{\'DEVICE_DATA_BUS_TYPE\'|translate}} *\"><md-option ng-repeat=\"bus in device.template.dataBus\" ng-value=\"bus.id\">{{bus.name}}</md-option></md-select><div ng-messages=\"myForm.dataBus.$error\"><div ng-message=\"required\"><span translate=\"\">REQUIRED</span></div></div></md-input-container><md-select flex=\"30\" placeholder=\"{{\'DEVICE_USAGE_LEVEL\' | translate}}\" ng-model=\"deviceDetail.device.usageLevel\"><md-option ng-value=\"level.id\" ng-repeat=\"level in device.template.usageLevel\">{{level.name | translate}}</md-option></md-select></div><div layout=\"row\" layout-align=\"space-between\" layout-sm=\"column\"><md-input-container><label translate=\"\">DEVICE_LENGTH</label> <input name=\"length\" type=\"number\" max=\"999.99\" ng-model=\"deviceDetail.device.length\"></md-input-container><md-input-container><label translate=\"\">DEVICE_WIDTH</label> <input name=\"width\" type=\"number\" max=\"999.99\" ng-model=\"deviceDetail.device.width\"></md-input-container><md-input-container><label translate=\"\">DEVICE_HEIGHT</label> <input name=\"height\" type=\"number\" max=\"999.99\" ng-model=\"deviceDetail.device.height\"></md-input-container></div><p class=\"section-title\" translate=\"\">ELECTRICITY_INFO</p><div layout=\"row\" layout-align=\"space-between center\" layout-sm=\"column\"><md-input-container><md-select placeholder=\"{{\'DEVICE_ELECTRICITY_SUPPLY\'|translate}}\" ng-model=\"deviceDetail.device.electricitySupply\"><md-option ng-value=\"supply.id\" ng-repeat=\"supply in device.template.electricitySupply\">{{supply.name | translate}}</md-option></md-select></md-input-container><md-input-container><md-select ng-model=\"deviceDetail.device.hasMultipleVoltage\" placeholder=\"{{\'WORKING_VOLTAGE\'|translate}}\"><md-option ng-value=\"false\" translate=\"\">SINGLE_WORKING_VOLTAGE</md-option><md-option ng-value=\"true\" translate=\"\">MULTIPLE_WORKING_VOLTAGE</md-option></md-select></md-input-container><md-input-container><md-select ng-if=\"!deviceDetail.device.hasMultipleVoltage\" ng-model=\"deviceDetail.device.singleWorkingVoltage\" placeholder=\"{{\'SINGLE_WORKING_VOLTAGE\'|translate}}\"><md-option ng-repeat=\"volt in device.template.singleWorkingVoltage\" ng-value=\"volt.id\">{{volt.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"deviceDetail.device.hasMultipleVoltage\" class=\"padding-hack\"><label translate=\"\">MULTIPLE_WORKING_VOLTAGE</label> <input name=\"multipleWorkingVoltage\" ng-model=\"deviceDetail.device.multipleWorkingVoltage\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" layout-sm=\"column\"><md-input-container><label translate=\"\">DEVICE_STANDBY_CURRENT</label> <input name=\"standbyCurrent\" ng-model=\"deviceDetail.device.standbyCurrent\"></md-input-container><md-input-container><label translate=\"\">DEVICE_MAX_CURRENT</label> <input name=\"standardCurrent\" ng-model=\"deviceDetail.device.standardCurrent\"></md-input-container></div><p class=\"section-title\" translate=\"\">PROOFING_INFO</p><div layout=\"row\" layout-align=\"space-between\" layout-sm=\"column\"><md-input-container><label translate=\"\">DEVICE_WATER_PROOF</label> <input name=\"waterProof\" ng-model=\"deviceDetail.device.waterProof\"></md-input-container><md-input-container><label translate=\"\">DEVICE_ANTI_STATIC</label> <input name=\"antiStatic\" ng-model=\"deviceDetail.device.antiStatic\"></md-input-container></div><p class=\"section-title\" translate=\"\">CONTACT_INFO</p><div layout=\"row\" layout-align=\"space-between\" layout-sm=\"column\"><md-input-container><label translate=\"\">DEVICE_CONTACT_TEL</label> <input name=\"tel\" ng-model=\"deviceDetail.device.contactTel\"></md-input-container><md-input-container><label translate=\"\">DEVICE_CONTACT_EMAIL</label> <input name=\"email\" ng-model=\"deviceDetail.device.contactEmail\"></md-input-container></div><div layout=\"row\" layout-align=\"end\" layout-sm=\"column\" layout-align-sm=\"center\" ng-if=\"!device.edit\"><md-button ng-click=\"deviceDetail.createDeviceDetail()\" class=\"md-raised md-primary\" ng-disabled=\"myForm.$invalid\"><span translate=\"\">CREATE</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"deviceDetail.skipToNext()\"><span translate=\"\">DEVICE.SKIP_TO_NEXT</span></md-button></div><div layout=\"row\" layout-align=\"end\" layout-sm=\"column\" layout-align-sm=\"center\" ng-if=\"device.edit\"><md-button ng-click=\"deviceDetail.updateDeviceBasic()\" class=\"md-raised md-primary\" ng-disabled=\"myForm.$invalid\"><span translate=\"\">SAVE</span></md-button><md-button ng-click=\"deviceDetail.cancelEditBasic()\" class=\"md-raised md-accent\"><span translate=\"\">GIVEUP_EDITING</span></md-button></div></md-content></form></md-content></div>");
$templateCache.put("app/devices/create/device-create-other-files-upload.html","<div layout=\"column\" id=\"other-file-upload\" layout-align=\"center center\"><div translate=\"\" class=\"tip\">UPLOADED.CLICK_TO_CHANGE_OR_UPLOAD_FILE</div><div layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div ng-repeat=\"m in uploader.materials\" flex=\"\" flex-gt-xs=\"33\" layout-align=\"center center\" layout=\"column\"><div class=\"file-upload\" ng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\"><div class=\"file-box clickable\" layout-align=\"center center\" layout=\"column\" ng-class=\"{light: m.lastState===\'DONE\', dark: m.lastState!=\'DONE\', hovering: hovering}\"><i class=\"fa\" ng-class=\"m.icon\" ng-if=\"m.isFontAwesomeIcon\"></i> <i class=\"material-icons\" ng-if=\"!m.isFontAwesomeIcon\">{{m.icon}}</i><div class=\"label\" translate=\"\">{{m.label}}</div><md-progress-circular md-value=\"m.progress\" ng-if=\"m.state === \'ING\'\"></md-progress-circular></div><input type=\"file\" class=\"upload\" uploader=\"m.fileUploader\" nv-file-select=\"\" filters=\"fileName\" ng-disabled=\"m.state===\'ING\'\"></div><div class=\"hint\"><span ng-if=\"hovering\" ng-show=\"m.lastState===\'DONE\'\" translate=\"\">UPLOADED.CLICK_TO_CHANGE_FILE</span> <span ng-if=\"hovering\" ng-show=\"m.lastState!=\'DONE\'\" translate=\"\">UPLOADED.CLICK_TO_UPLOAD_FILE</span></div></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap=\"\" ng-if=\"!uploader.deviceController.edit\"><md-button class=\"md-raised md-primary\" ng-click=\"uploader.skipToNext()\" md-no-ink=\"false\" md-ripple-size=\"auto\"><span translate=\"\">DEVICE.SKIP_TO_NEXT</span></md-button></div>");
$templateCache.put("app/devices/create/device-create.html","<div layout-align=\"center center\" layout=\"row\" id=\"device-create\" ng-if=\"device.edit\"><div class=\"go-back\" ui-sref=\"devices.show({model: device.device.model})\"><i class=\"fa fa-chevron-left\"></i><span translate=\"\">DEVICE.BACK_TO_DETAIL_PAGE</span></div></div><div layout=\"row\" layout-align=\"center center\" class=\"device-tabs\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"device.selectedTab\" flex-sm=\"100\" flex-md=\"80\" md-swipe-content=\"\" md-center-tabs=\"\" layout-align=\"space-around center\" flex-lg=\"70\" flex-gt-lg=\"60\"><md-tab ng-disabled=\"device.infoLocked\"><md-tab-label><div ng-if=\"!device.edit\"><div class=\"circle\">1</div><span translate=\"\">FILL_OUT_FORM</span></div><div ng-if=\"device.edit\" translate=\"\">EDIT_DEVICE_INFO</div></md-tab-label><md-tab-body><div ng-include=\"\'app/devices/create/device-create-info.html\'\"></div></md-tab-body></md-tab><md-tab ng-disabled=\"device.layoutLocked\"><md-tab-label><div ng-if=\"!device.edit\"><div class=\"circle\">2</div><span translate=\"\">UPLOAD_BOARD_FILES</span></div><div ng-if=\"device.edit\" translate=\"\">EDIT_BOARD_FILE</div></md-tab-label><md-tab-body><md-content ng-controller=\"FileUploadController as uploader\" ng-show=\"!device.layoutLocked\"><div ng-include=\"\'app/devices/create/device-create-board-layout-upload.html\'\"></div></md-content></md-tab-body></md-tab><md-tab ng-disabled=\"device.otherFilesLocked\"><md-tab-label><div ng-if=\"!device.edit\"><div class=\"circle\">3</div><span translate=\"\">UPLOAD_OTHER_FILES</span></div><div ng-if=\"device.edit\" translate=\"\">EDIT_DEVICE_OTHER_FILE</div></md-tab-label><md-tab-body><md-content ng-show=\"!device.otherFilesLocked\" ng-controller=\"OtherFileUploadController as uploader\"><div ng-include=\"\'app/devices/create/device-create-other-files-upload.html\'\"></div></md-content></md-tab-body></md-tab><md-tab ng-disabled=\"device.detailInfoLocked\"><md-tab-label><div ng-if=\"!device.edit\"><div class=\"circle\">5</div><span translate=\"\">DEVICE.DEVICE_DETAIL_INFO</span></div><div ng-if=\"device.edit\" translate=\"\">DEVICE.EDIT_DEVICE_DETAIL_INFO</div></md-tab-label><md-tab-body><md-content class=\"md-padding\" ng-controller=\"OptionalInfoController as deviceDetail\"><div ng-include=\"\'app/devices/create/device-create-optional-info.html\'\"></div></md-content></md-tab-body></md-tab><md-tab ng-disabled=\"device.driversLocked\"><md-tab-label><div ng-if=\"!device.edit\"><div class=\"circle\">4</div><span translate=\"\">DEVICE.DRIVER</span></div><div ng-if=\"device.edit\" translate=\"\">DEVICE.EDIT_DRIVER</div></md-tab-label><md-tab-body><md-content ng-controller=\"DeviceCreateBindingController as binding\" class=\"md-padding\"><div ng-include=\"\'app/devices/create/device-create-binding.html\'\" layout=\"row\"></div></md-content></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/devices/show/device-show.html","<div cg-busy=\"device.promise\" class=\"busy-mask\"><div flex-offset=\"10\" flex=\"80\" layout=\"column\"><div layout-xs=\"column\" layout-gt-xs=\"row\" class=\"section\" layout-align-xs=\"center center\"><div flex=\"\" flex-gt-xs=\"20\" class=\"device-avatar\"><random-avatar seed=\"{{device.id}}\"></random-avatar></div><div flex=\"\" layout-xs=\"column\" layout-gt-xs=\"row\" layout-align-xs=\"center start\"><div class=\"device-name\" flex-gt-xs=\"80\"><i hide-xs=\"\" class=\"fa fa-calculator device-icon\"></i>{{device.device.name}}</div><div layout=\"column\" layout-align=\"center center\"><md-button ui-sref=\"devices.update({model: device.device.model})\" class=\"md-raised md-primary\" ng-if=\"device.showEditButton\"><span translate=\"\">EDIT_DEVICE</span></md-button></div></div></div><div class=\"section\" layout-xs=\"column\" layout-gt-xs=\"row\"><div class=\"row-section\" flex=\"\" flex-gt-xs=\"60\" layout=\"column\"><div flex=\"\" class=\"section-title\" translate=\"\">DEVICE_DESCRIPTION</div><div flex=\"\" class=\"device-description\">{{device.device.description || \'EMPTY\' | translate}}</div><div flex=\"\" class=\"section-title\" translate=\"\">DEVICE_KEYWORD</div><div flex=\"\" class=\"device-description\" layout=\"row\"><div ng-repeat=\"keyword in device.device.keyWords\"><span>{{keyword}}{{$last?\'\':\', \'}}</span></div><span ng-show=\"device.device.keyWords.length === 0\" translate=\"\">NO_KEYWORDS</span></div><div flex=\"\" class=\"section-title\" translate=\"\">DEVICE_MODEL</div><div flex=\"\" class=\"device-description\">{{device.device.model}}</div></div><div flex=\"\" flex-gt-xs=\"35\" flex-offset-gt-xs=\"5\" layout=\"column\"><div class=\"section-title\" translate=\"\">DEVICE.DRIVER</div><md-list class=\"no-padding\"><md-list-item ng-repeat=\"item in device.drivers\"><span class=\"clickable driver-link\" ui-sref=\"raps.show({name:item.name})\">{{item.name}}</span></md-list-item><span ng-if=\"device.drivers.length === 0\" translate=\"\">EMPTY</span></md-list></div></div><div flex=\"\" class=\"section\" layout-xs=\"column\" layout-gt-xs=\"row\"><div class=\"row-section\" flex=\"\" flex-gt-xs=\"60\" layout=\"column\"><div class=\"section-title\" translate=\"\">HARDWARE_INTERFACE</div><md-content flex=\"\" ng-controller=\"PinsLayoutShowController as pinsLayout\"><div ng-include=\"\'app/devices/show/pins-layout-show.html\'\"></div></md-content></div><div flex=\"\" flex-gt-xs=\"35\" flex-offset-gt-xs=\"5\" layout=\"column\"><div class=\"section\"><div flex=\"\" class=\"section-title\" translate=\"\">BASIC_INFO</div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_MANUFACTURE</div><div>{{device.device.manufacturer || \'EMPTY\' | translate}}</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_PRODUCTION_PHASE</div><div>{{device.device.productionPhase || \'EMPTY\' | translate}}</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_USAGE_LEVEL</div><div>{{device.device.usageLevel.name || \'EMPTY\' | translate}}</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_SIZE</div><div ng-show=\"device.device.length || device.device.width || device.device.height\">{{device.device.length}}cm * {{device.device.width}}cm * {{device.device.height}}cm</div><div ng-show=\"!device.device.length && !device.device.width && !device.device.height\" translate=\"\">EMPTY</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_DATA_BUS_TYPE</div><div ng-repeat=\"bus in device.device.dataBus\"><span>{{bus.name}}{{$last?\'\':\', \'}}</span></div><span ng-if=\"!device.device.dataBus || device.device.dataBus.length==0\" translate=\"\">EMPTY</span></div></div><div class=\"section\"><div class=\"section-title\" translate=\"\">DEVICE.OTHER_INFO</div><div ng-if=\"!device.uploaded\"><span translate=\"\">UPLOADED.EMPTY</span></div><div ng-repeat=\"key in device.uploaded\"><div layout=\"row\"><div flex=\"20\" class=\"label\">{{\'UPLOADED.\' + key|translate}}</div><a ng-click=\"device.downloadOtherFile(key)\" translate=\"\" class=\"download-btn\">DOWNLOAD</a></div></div></div><div class=\"section\"><div flex=\"\" class=\"section-title\" translate=\"\">PROOFING_INFO</div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_ANTI_STATIC</div><div flex=\"\">{{device.device.antiStatic || \'EMPTY\' | translate}}</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_WATER_PROOF</div><div flex=\"\">{{device.device.waterProof || \'EMPTY\' | translate}}</div></div></div><div><div flex=\"\" class=\"section-title\" translate=\"\">ELECTRICITY_INFO</div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">WORKING_VOLTAGE</div><div flex=\"\" ng-if=\"!device.device.hasMultipleVoltage\">{{device.device.singleWorkingVoltage.name || \'EMPTY\' | translate }}</div><div flex=\"\" ng-if=\"device.device.hasMultipleVoltage\">{{device.device.multipleWorkingVoltage|| \'EMPTY\' | translate}}</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_STANDBY_CURRENT</div><div flex=\"\" ng-show=\"device.device.standbyCurrent\" translate=\"\" translate-value-current-value=\"{{device.device.standbyCurrent}}\">CURRENT_UNIT_MMA</div><div flex=\"\" ng-show=\"!device.device.standbyCurrent\" translate=\"\">EMPTY</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_MAX_CURRENT</div><div flex=\"\" ng-show=\"device.device.standardCurrent\" translate=\"\" translate-value-current-value=\"{{device.device.standardCurrent}}\">CURRENT_UNIT_MA</div><div flex=\"\" translate=\"\" ng-show=\"!device.device.standardCurrent\">EMPTY</div></div><div flex=\"\" layout=\"row\"><div flex=\"50\" class=\"label\" translate=\"\">DEVICE_ELECTRICITY_SUPPLY</div><div flex=\"\">{{device.device.electricitySupply.name || \'EMPTY\' | translate}}</div></div></div></div></div><div flex=\"\" class=\"section no-border\"><div class=\"section-title\" translate=\"\">CONTACT_INFO</div><div layout=\"row\"><div layout=\"row\" flex=\"50\"><div flex-xs=\"50\" flex-gt-xs=\"20\" class=\"label\" translate=\"\">DEVICE_CONTACT_TEL</div><div>{{device.device.contactTel || \'EMPTY\' | translate}}</div></div><div layout=\"row\" flex=\"50\"><div flex-xs=\"50\" flex-gt-xs=\"20\" class=\"label\" translate=\"\">DEVICE_CONTACT_EMAIL</div><div>{{device.device.contactEmail || \'EMPTY\' | translate}}</div></div></div></div></div></div>");
$templateCache.put("app/devices/show/pins-layout-show.html","<div layout=\"column\" layout-align=\"center start\" id=\"imageCanvas\" ng-if=\"pinsLayout.layoutImageSuccess\"><div layout=\"row\" layout-align=\"start start\" style=\"width:100%;\"><div board-show=\"{ imageSrc: pinsLayout.imageSrc }\" class=\"boardCanvas\"></div></div><section layout=\"row\" layout-wrap=\"\" style=\"margin: 5px 0 0 20px;\" ng-if=\"pinsLayout.hasInputPins()\" layout-align=\"start center\"><div style=\"margin:0px 3px;font-size:0.9em\" translate=\"\">DEVICE.INPUT_PINS</div><div ng-repeat=\"pin in pinsLayout.inputPins\" style=\"margin-left: 5px;outline: medium;font-size:0.9em\" layout=\"row\" layout-align=\"center center\" ng-click=\"pinsLayout.striking(pin)\"><div ng-class=\"pin.getCssClass() + \' pin-caption\'\" ng-style=\"{\'background-color\': pinsLayout.generateColor(pin.pinCategoryCode)}\"></div><div style=\"margin-left:3px;\">{{pin.pin}}</div></div></section><section layout=\"row\" layout-wrap=\"\" style=\"margin: 5px 0 0 20px;\" ng-if=\"pinsLayout.hasOutputPins()\" layout-align=\"start center\"><div style=\"margin:0px 3px;font-size:0.9em\" translate=\"\">DEVICE.OUTPUT_PINS</div><div ng-repeat=\"pin in pinsLayout.outputPins\" style=\"margin-left: 5px;outline: medium;font-size:0.9em\" layout=\"row\" ng-click=\"pinsLayout.striking(pin)\"><div ng-class=\"pin.getCssClass() + \' pin-caption\'\" ng-style=\"{\'background-color\': pinsLayout.generateColor(pin.pinCategoryCode)}\"></div><div style=\"margin-left:3px;\">{{pin.pin}}</div></div></section></div><span ng-if=\"!pinsLayout.layoutImageSuccess\" translate=\"\">EMPTY</span>");}]);